import React, { Component } from 'react'
import ExplanationGallery from '../../../ui/takeQuiz/ExplanationGallery'
import FreeChoiceCategorySelectionPage from '../../../ui/takeQuiz/FreeChoiceCategorySelectionPage'
//Custom Components
import SplashScreen from '../../../ui/takeQuiz/SplashScreen'
import TakeQuizContainer from '../../../ui/takeQuiz/TakeQuizContainer'
import ScoreWheel from '../../../ui/takeQuiz/ScoreWheel'
import MobileScoreWheel from '../../../ui/takeQuiz/MobileScoreWheel'
import QuestionWithImage from '../../../ui/takeQuiz/QuestionWithImage'
import NavigationButton from '../../../ui/takeQuiz/NavigationButton'
import questionImage from '../../../images/png/dummyQuestion1.png'
import LoadingSpinner from '../../../components/LoadingSpinner';
import { BeatLoader } from 'react-spinners';
import MomentTz from 'moment-timezone'
import FeedbackPopup from '../../../ui/takeQuiz/FeedbackPopup'
import TextEditor from '../../../components/TextEditor'
import { convertFromRaw, EditorState } from 'draft-js';
import QuizProgressBar from '../../../ui/takeQuiz/QuizProgressBar'
import { isMobile, isBrowser } from 'react-device-detect';
import '../../../css/TakeQuiz.css';
import LiveAnalytics from '../../../ui/takeQuiz/liveAnalytics'
import MathParserUtil from '../../../lib/math-parser'
import { MQTOptions } from '../../../lib/mqt';
import VectorParser, { VectorVariableMap } from '../../../lib/vector-math-parser';
import { NotificationManager } from 'react-notifications';
import VectorParserUtil from '../../../lib/vector-math-parser'
import { AppSetting, AppProperties, createVideoLinkIframe } from '../../../common/functions';
import { GlobalContext } from '../../../GlobalContext'

import { Button, Card, CardContent, CardHeader, LinearProgress, Typography, Grid, Snackbar, Alert, IconButton, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material'
import SFCategoryProgressCard from './components/SFCategoryProgressCard'
import "./style.css"
import { FaRegClock } from "react-icons/fa6";
import { TbTargetArrow } from "react-icons/tb";
import SFAssignmentCompletion from '../SFAssignmentCompletion/SFAssignmentCompletion';
import VerticalProgress from './components/VerticalProgress';
import MathJax from '../../../components/react-mathjax-preview';
import SFMCRadioTypeAnswers from './components/answers/SFMCRadioTypeAnswers'
import SFFeedbackPopup from './components/SFFeedbackPopup'
import SFMCChecboxTypeAnswers from './components/answers/SFMCChecboxTypeAnswers'
import SFTextboxTypeAnswer from './components/answers/SFTextboxTypeAnswer'
import AnswerTypeRPTextBox from '../../../ui/takeQuiz/AnswerTypeRPTextBox'
import MQTQuestion from '../../../ui/takeQuiz/mqt/MQTQuestion'
import { VectorAnswers, VectorQuestion } from '../../../ui/takeQuiz/vectors'
import SFVectorTypeAnswer from './components/answers/SFVectorTypeAnswer'
import SFQuestionAndAnswer from './components/SFQuestionAndAnswer'
import { Cell, DialogContainer } from 'react-md'
import SFTakequizNavbar from './components/SFTakequizNavbar'
import KeyBoardInstruction from '../../../components/KeyBoardInstruction'
import { FaRegCircleCheck } from "react-icons/fa6";
import { CgCloseO } from "react-icons/cg";
import SFExplanation from './components/SFExplanation'
import SFSplashScreen from './components/SFSplashScreen'
import { FiTarget } from "react-icons/fi";
import { FaCaretUp, FaCaretDown } from "react-icons/fa";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { confirmAlert } from 'react-confirm-alert';
import { IoCheckmark } from "react-icons/io5";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { FaBookmark, FaRegBookmark } from "react-icons/fa6";
import Bookmark from './components/Bookmark'
import SFOnePageTest from './components/SFOnePageTest'
import { VariableMap } from '../../../lib/types'
import moment from 'moment-timezone'
import math, { simplify } from "mathjs";


import { checkIsDecimalOnly, checkIsENotationOnly,countSignificantFiguresForScifi,
  countSignificantFigures
 } from "../../../components/vectors/commonHelpers"
import SFDotsProgress from './components/SFDotsProgress'
import ExplanationAndTutorials from './components/ExplanationsAndTutorials'



const quizBundleDummy = {
  'splashScreen': 'During this unit, you will be presented with a variety of math or physics questions, which will help in the design and improvement of Essential Skills units. You may not  know how to answer some of these questions, and this is ok. We want to gauge how  much you already know about these topics to help us construct future instructional modules.  If you are unsure of how to approach a question, make the best guess you can without consulting  outside materials. Your grade will be changed to show full credit (after this unit closes) for giving  an honest effort on every problem.',
  'quizName': 'Demo Quiz'

};



var submitClickInProgress = false; // Semaphore to prevent double click
var remainingCatSubcatMap = {}; //CategoryID - Array(SubcategorieIDs)
var totalSCCount = 0;
var remaningSubCatCount = 0;
var remainingCategorySet = [];
var currentCategoryCounter = 0;
const breakCheck = 50;
// const isDebug = true;


//var totalSCCountegoriesSet = new Set();

export default class SFPreviewQuestion extends Component {

  AppSetting = AppSetting();
  appProperties = AppProperties();
  timeZone = this.appProperties.currentUserData.timeZone || 'America/New_York'
  static contextType = GlobalContext
  constructor(props) {
    super(props)
    this.params = new URLSearchParams(this.props.location.search)
    this.state = this.resetState();

    this.questionStartTimeStamp = "";
    this.state.gnbCount = -1;


    this.saveElapsedTimeForExplanations = this.saveElapsedTimeForExplanations.bind(this);
    this.onExplanationClick = this.onExplanationClick.bind(this);
    this.onStartClick = this.onStartClick.bind(this);
    this.onSubmitClick = this.onSubmitClick.bind(this);
    this.onPrevClick = this.onPrevClick.bind(this);
    this.onAnswerEntered = this.onAnswerEntered.bind(this);
    this.onAnswerClick = this.onAnswerClick.bind(this);
    this.checkAnswerIsCorrect = this.checkAnswerIsCorrect.bind(this);
    this.removeElementFromArray = this.removeElementFromArray.bind(this);
    this.showCorrectAnswer = this.showCorrectAnswer.bind(this);
    this.onSaveAndExit = this.onSaveAndExit.bind(this);
    this.appendExplanations = this.appendExplanations.bind(this);

    this.getExplanationData = this.getExplanationData.bind(this);
    this.onFeedbackClick = this.onFeedbackClick.bind(this);
    this.onFeedbackCloseClick = this.onFeedbackCloseClick.bind(this);
    this.findFeedbackText = this.findFeedbackText.bind(this);
    this.liveAnalyticsClick = this.liveAnalyticsClick.bind(this);
    this.onliveAnalyticsCloseClick = this.onliveAnalyticsCloseClick.bind(this);

    window.localStorage.setItem("gnbArr", JSON.stringify([]))
  }

  quizTimerTimeOut = null;

  resetState = () => {
    return ({
      isDebug: false,
      quizId: parseInt(this.params.get("quiz_id"), 10),
      subject_id: parseInt(this.params.get("subject_id"), 10),
      topic_id: parseInt(this.params.get("topic_id"), 10),
      category_id: parseInt(this.params.get("category_id"), 10),
      subcategory_id: parseInt(this.params.get("subcategory_id"), 10),
      question_id: parseInt(this.params.get("question_id"), 10),
      userId: window.localStorage.getItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + "USER_NAME"),//"test144",//this.props.match.params.quiz_name,
      quizName: decodeURIComponent(this.params.get("quiz_name")),
      courseName: decodeURIComponent(this.params.get("course_name")),
      courseID: parseInt(this.params.get("course_id")),
      quizBundle: quizBundleDummy,
      subSectionID: 0,
      showSplashScreen: true,
      showAnswerResponse: false,
      answerCorrect: true,
      hideNext: true,
      hidePrev: true,
      hideSubmit: false,
      subcategoriesArr: null,
      questionArr: null,
      elapsedTime: 0,
      categoriesMap: {},// categoryID - category name,score
      subTopcatSubcatMap: {},
      subCategoryCategoryMap: {}, // subcategoryID - categoryId,category name
      NOCQCMap: {},//categoryID - categoryFlag
      catNOCQCMap: {},
      SCQCMap: {},
      subCQCMap: {},
      CatRI: {},
      SubCatRI: {},
      SQCBackup: {},
      categoryQuestionsMap: {},//categoryId - question array
      categorySubcategoryMap: {}, //CategoryID - Array(SubcategorieIDs)
      subCategoryQuestionMap: {}, // SubCategoryID - Array(QuestionsIDs)
      questionMap: {}, //QuestionID - QuestionValue and answer array
      CSAPMap: {},// categoryID - index of the Cat's Subcat array
      IsCatChoosenFTGNB: {},//
      categoryAvailableQuestion: {},
      subcategoryAvailableQuestion: {},
      subCategoryQuestionsCount: {},
      correctAnswerMap: {},// subjectID_TopicID_categoryID_subcategoryID_QuestionID - AnswerID
      subcategoriesMap: {},// subcategoryID - subcatArr
      surveyQuestionMap: {}, // subjectID_TopicID_categoryID_subcategoryID_QuestionID - Question values
      surveyQuestionAnswerMap: {},// subjectID_TopicID_categoryID_subcategoryID_QuestionID - answer array
      surveyQuestionIdArr: [], //question_id array
      surveyQPointer: 0,
      surveyPreviousQuestionId: 0,
      correctAnswerArr: [],
      categoryArray: [],
      categorySet: [],
      categoryForWheel: [],
      isFirstQuestion: true,
      isCategoryRandom: true,
      hasMasteredQuiz: false,
      getNextBatch: false,
      categoryArrayIndex: 0,
      randomCategory: 0,
      NOCQC: 1,
      questionLength: 0,
      isLockedOut: false,
      QSS: new Set(),
      surveyQuestion: false,
      randomQuestionID: 0,
      randomQuestion: 0,
      randomSubCategory: 0,
      RandomSubcategoryOrder: new Set(),
      currentQuestionType: 0,
      currentVariableMap: undefined,
      displayQuestionText: "",
      displayAnswerArr: [],
      answerType: 0,
      forCheckBoxQuestion: 1,
      selectedAnswer: [],
      masteryCount: 0,
      maxWrong: 0,
      skillsMasterd: 0,
      numberOfCategories: 0,
      skillTotal: 0,
      completedCategoryArray: [],
      questionsCorrect: 0,
      questionsAttended: 0,
      checkedAnswerIs: [],
      quizAttempt: 0,
      allQOver: true,
      submitButtonDisplay: true,
      tryAgainButtonDisplay: false,
      masteredCategories: [],
      tryAgainCount: 1,
      forceUpdateHandler: false,
      displayCorrectAnswer: false,
      splashScreen: "",
      isTest: parseInt(this.params.get("quiz_type")),
      isTimerEnabled: false,
      pageLoading: true,
      surveyQuestionsRetrieved: false,
      isSurveyOn: 0,
      showSkip: false,
      submitClicked: true,
      showSubmitLoader: false,
      categoryMasteryCount: {},//key : sub_topc_cate value categoryMastery count\
      explanationGalleryVisible: false,
      explanations: null,
      explanationButtonDisplay: false,
      subcategoryExplanationMap: {},
      categoryExplanationMap: {},
      topicExplanationMap: {},
      feedbackPopupVisible: false,
      feedbackButtonVisible: false,
      feedbackCurrentQuestion: null,
      feedbackAnswer: null,
      feedbackOn: true,
      liveAnalyticsButtonVisible: false,
      liveAnalyticsPopup: false,
      liveAnalytics: null,
      mqt_options: {},
      isAbsoluteTimerOn: 0,
      selectedAnswerDetails: {},
      showFreeChoice: false,
      categoryIsRequired: null,
      showCategorySelectionPage: false,
      freeChoiceCount: 0,
      questionStartTime: new Date(),
      question_attempt: 1,
      currentVectorVariable: {},
      freeFormVectorOptions: {},
      vectorBelowQuestionText: '',
      isGNBCallFirstQuestion: {},
      categoryRandomizedKeys: [],
      CRQMap: {},
      SCRQMap: {},
      isResetSubCatWeight: {},
      CategoryNoOfQuestions: {},
      NumberOfAttendedQuestions: {},
      practiceCount: 0,
      allowPractice: true,
      isCurrentQuestionNonGraded: false,
      reasoningElements: [],
      connectingWords: [],
      conclusionSentences: [],
      isConclusionSentenceRequired: false,
      reasoningChainAnswerFormat: "",
      showReasoningElementCategoryInfo: false,

      currentAccuracyGoal: 0,
      currentTimeGoal: 0,
      splashScreenCategories: [],
      categoriesData: [],
      categoryAccuracyGoal: 0,
      categoryTimeGoal: 0,
      count: 0, // this is for simple local question count check
      hideNavAndCat: false,
      hideQuestion: false,
      showSaveAndExit: false,
      invalidQuiz: false, // to check whether student attended the LTI assignment from canvas and not directlty logging to SF
      //   catRoundCompleted:[]
      carmenAssignmentLink: "",
      mainQAArray: [], // for one page test mode
      answersMap: {},
      scientificAnswerEvalMap: {},
      bookmarkQuestionIDMap: {},
      isAllQuestionsAnswered: true,
      onePageTestSaving: false,
      onePageTestLoading: false,
    })
  }



  componentDidUpdate(prevProps, prevState) {
    if (this.state !== prevState) {
      const myAppState = this.state;
      const { updateAppState } = this.context;
      updateAppState(myAppState);
    }
    if (this.state.randomCategory !== prevState.randomCategory) {
      this.setCategoryGoals();
    }

    if (this.state.selectedAnswer !== prevState.selectedAnswer) {
      console.debug("SOMETHING HAPPENED", this.state.selectedAnswer, prevState.selectedAnswer)
    }

    /* window.addEventListener("beforeunload", function(e) {
      return true;
    }); */

  }

  componentDidMount() {
    const { pathname, search } = this.props.location;


    if (this.props.updateQuizURL && pathname && search) {

      this.props.updateQuizURL(pathname + search);
    }

    if (this.appProperties?.currentUserData?.isAnonymous && JSON.parse(this.appProperties?.currentUserData?.isAnonymous)) {
      this.setState({
        isAnonymous: true,
      })
      window.localStorage.setItem("anonymous_assignment_url", window.location.href)
    } else {
      this.setState({
        isAnonymous: false
      })
    }

    this.props.subscribeToZoomEvent(() => {
      console.log("Zoomed");
      this.forceUpdate();

    });

    var tempSplashScreen, tempAltSplashScreen
    //Get SPlash Screen bug-tracker#228
    if (this.props.apiService !== undefined) {
      let payload = {
        subject_id: this.state.subject_id,
        topic_id: this.state.topic_id,
        category_id:this.state.category_id,
        subcategory_id: this.state.subcategory_id,
        question_id: this.state.question_id
      };


      let responsePromise = this.props.apiService({
        method: 'POST',
        url: '/getQuestionsById',
        data: payload
      });

      responsePromise.then(res => {
        if (res.data.status === 1 && res.data.message) {
          if (res.data.message === 'not from canvas') {
            console.debug("finalURL", finalURL)

            this.setState({
              pageLoading: false,
              showSplashScreen: true,
              quizWindowEnded: true,
              invalidQuiz: true,
              carmenAssignmentLink: finalURL,
            })
            /* NotificationManager.error('You have attended an invalid quiz. Please attend this assignment in Carmen.', 'Invalid Quiz Attempted', 8000); */
            return;
          }

        }
        if(res.data.data){
          let question = res.data.data
          let uniqueID = `${question.subject_id}_${question.topic_id}_${question.category_id}_${question.subcategory_id}_${question.question_id}`;
          let answerDataArr = this.getAnswerFromQuestion(question);
          let answerFormula = question.answer_formula ? { ...question.answer_formula, formulaMap: question.answer_formula.formulaArray ? MathParserUtil.buildAnswerFormulasMap(question.answer_formula.formulaArray) : null } : null
          var tempQuesId = question.subject_id + "_" + question.topic_id + "_" + question.category_id + "_" + question.subcategory_id + "_" + question.question_id;
          let tempQuestionMap = {};
          let tempCorrectAnswerMap = {};
          if (tempQuesId) {
              tempQuestionMap[tempQuesId] = question;
          }
          let tempCorrectAnswerArr = [];
          var tempAnswerArr = question.answers;
          if (tempAnswerArr !== undefined && tempAnswerArr !== null) {
            for (var j = 0; j < tempAnswerArr.length; j++) {
  
              if (tempAnswerArr[j].is_answer === 1) {
  
                tempCorrectAnswerArr.push(tempAnswerArr[j].answer_id);
                tempCorrectAnswerMap[tempQuesId] = tempCorrectAnswerArr;
  
  
              }
            }
          }
          let tempVectorsVarMap;
          if (question.question_type === 3) {
            tempVectorsVarMap = VectorParser.buildQuestionVariablesMap(question.vector_question_variables);
            if (tempVectorsVarMap && tempVectorsVarMap.isValid()) {
              let enableIdenticalVector = false;
              tempVectorsVarMap.generateValues(enableIdenticalVector, question.vector_settings_data);
            }
          }

          let currentVariableMap = this.getCurrentVariableMapFromQuestion(question, answerDataArr);

          let questionText = question.question_text;
          questionText = questionText.replaceAll("<figure>", "")
          questionText = questionText.replaceAll("</figure>", "")

          this.setState({
            currentPreviewQuestionData: res.data.data,
            pageLoading: false,
            currentVectorVariable: tempVectorsVarMap,
            displayQuestionText:questionText,
            displayAnswerArr:answerDataArr,
            answerType: question.answer_type,
            forCheckBoxQuestion: question.for_checkbox_question,
            answerDisplayStyle: question.answerDisplayStyle,
            currentQuestionType: question.question_type,
            mqt_options: question.mqt_options,
            currentVectorSettings: question.vector_settings_data,
            answer_formula: answerFormula,
            vectorAnswerFormulas: question.vector_answer_formulas,
            freeFormVectorOptions: question.freeform_vector_options,
            vectorBelowQuestionText: question.vector_below_question_text,
            randomSubCategory: `${question.subject_id}_${question.topic_id}_${question.category_id}_${question.subcategory_id}`,
            randomCategory: `${question.subject_id}_${question.topic_id}_${question.category_id}`,
            randomQuestionID:tempQuesId,
            questionMap : tempQuestionMap,
            correctAnswerMap: tempCorrectAnswerMap,
            correctAnswerArr: tempCorrectAnswerArr,
            // questionText: this.constructAndReturnQuestionText(question),
            questionType: question.question_type,
            answerType: question.answer_type,
            answerDataArr: answerDataArr,
            answerFormula: answerFormula,
            answerDisplayStyle: question.answerDisplayStyle,
            mqtOptions: question.mqt_options,
            vectorSettingsData: question.vector_settings_data,
            vectorAnswerFormulas: question.vector_answer_formulas,
            vector_variable_map_string: tempVectorsVarMap ? tempVectorsVarMap.toString() : "",
            currentVariableMap: currentVariableMap,
          }, () => {
            this.getExplanationData();
          })

        }
        if (res.data.data === null && res.data.message === "" && res.data.status === 0) {
          this.setState({ allowPractice: false, pageLoading: false });
        }
      }).catch(error => {
        console.error("Error when getting Quiz SplashScreen", error)

      })
    }
    else {
      //TODO Show Error saying makeAjaxRequest is undefined
    }
  }


  onStartClick(isFinalscore) {
    let categoryIsRequired = this.state.freeChoiceCount
    let freeChoiceCount = this.state.freeChoiceCount
    let showFreeChoice = this.state.showFreeChoice
    let practiceCount = this.state.practiceCount
    this.setState(this.resetState(), () => {
      this.setState({
        freeChoiceCount: freeChoiceCount,
        categoryIsRequired: categoryIsRequired,
        showFreeChoice: showFreeChoice,
        showSplashScreen: false,
        practiceCount: practiceCount,
      });

      var isUpdatedFinalscore = false;
      const ltiUserID = this.params.get("ltiUserID");
      const payload = {

        quiz_id: this.state.quizId,
        user_id: this.state.userId,//"test123",
        quiz_name: this.state.quizName, //"test 123"
        quiz_attempt: this.state.quizAttempt,
        course_id: parseInt(this.params.get("course_id")),
        section_id: parseInt(this.params.get("section_id")),
        ltiUserID: ltiUserID ? ltiUserID : ""
      }
     
    })
  }



  addSingleQuestionAnswerState = (payload, question) => {
    let tempQuestionID = `${question.subject_id}_${question.topic_id}_${question.category_id}_${question.subcategory_id}_${question.question_id}`; 
    let qasPayload = {
      unique_id: tempQuestionID,
      subject_id: question.subject_id,
      topic_id: question.topic_id,
      category_id: question.category_id,
      subcategory_id: question.subcategory_id,
      question_id: question.question_id,
      quiz_id: this.state.quizId,
      other_state_map_string: JSON.stringify({
        tryAgainCount: this.state.tryAgainCount,
      }),
      ...payload,
    }
  }

  removeElementFromArray(arr, element) {
    var i = arr.indexOf(element);
    if (i !== -1) {
      arr.splice(i, 1);
    }
    ////console.log("questionIds Array value =",arr);
    return arr;
  }


  getAnswerFromQuestion = (question) => {
    // START
    let tempDisplayAnswerArr = [];
    if (question) {
      let tempDisplayQuestionText = question.question_text;

      if (question.alt_question_text !== undefined && question.alt_question_text !== null &&
        question.alt_question_text !== "") {
        try {
          var altQueText = question.alt_question_text
          altQueText = altQueText.replace(/\n/ig, ' ')
          //finding number of time image present
          var altQueTextCount = altQueText.split(';').length
          var imgTagCount = tempDisplayQuestionText.split('<img').length - 1
          console.debug((altQueTextCount / 2), "==", imgTagCount, "    ", altQueText.split(';').length, tempDisplayQuestionText.split('<img').length)
          if ((altQueTextCount / 2) == imgTagCount) {
            if (imgTagCount >= 1) {
              console.debug("greater than 1")
              var altQueTextArr = altQueText.split(';');
              var lastPosOfImg = 0
              console.debug(altQueTextArr.length)
              for (var i = 0; i <= altQueTextArr.length - 1; i = i + 2) {
                lastPosOfImg = tempDisplayQuestionText.indexOf("<img", lastPosOfImg)
                lastPosOfImg = lastPosOfImg + 4
                var b = "  title =\"" + altQueTextArr[i] + "\"  alt =\"" + altQueTextArr[i + 1] + "\" "
                var output = [tempDisplayQuestionText.slice(0, lastPosOfImg), b, tempDisplayQuestionText.slice(lastPosOfImg)].join('');
                tempDisplayQuestionText = output
              }
            }
          }
        } catch (e) {
          console.debug("ERROR in Alt Text  ", e)
        }
      }
      //Alt question Text
      question.question_text = tempDisplayQuestionText;
      tempDisplayAnswerArr = question.answers;
      console.debug("question.answers", question)
      tempDisplayAnswerArr?.forEach((_, index) => {
        if (tempDisplayAnswerArr[index].isChecked) {
          tempDisplayAnswerArr[index].isChecked = false
        }
      })

      if (question.question_type === 0 && [70,80].includes(question.answer_type )) {
        tempDisplayAnswerArr?.forEach((answerArr, cIndex) => {
          const vectorVariableMap = VectorParserUtil.buildQuestionVariablesMap(answerArr?.vectorAnswerVariable);
          let vectorSettingsData = question.vector_settings_data
          // Calculate newVectorValues
          const newVectorValues = vectorVariableMap 
              ? vectorVariableMap.getVectorsArray(
                  vectorSettingsData.enableIdenticalVector,
                  vectorSettingsData
                ).filter(value => value !== undefined)
              : [];
  
          // Check if newVectorValues is an array and has elements
          if (Array.isArray(newVectorValues) && newVectorValues.length > 0) {
              // Assign newVectorValues to answerArr
              answerArr.newVectorValues = [...newVectorValues];
          }
        })
    }

      //Alt answer text
      try {
        for (var i = 0; i <= question.answers?.length - 1; i++) {
          if (question.answers[i].answer_text !== undefined && question.answers[i].answer_text !== null &&
            question.answers[i].answer_text !== "" && question.answers[i].alt_answer_text !== undefined &&
            question.answers[i].alt_answer_text !== null && question.answers[i].alt_answer_text !== "") {
            var tempDisplayAnwserText = question.answers[i].answer_text
            var altAnsText = question.answers[i].alt_answer_text
            altAnsText = altAnsText.replace(/\n/ig, ' ')
            //finding number of time image present
            var altAnsTextCount = altAnsText.split(';').length
            var imgTagCount = tempDisplayAnwserText.split('<img').length - 1
            console.debug((altAnsTextCount / 2), "==", imgTagCount)
            if ((altAnsTextCount / 2) == imgTagCount) {
              if (imgTagCount >= 1) {
                // console.debug("Answer greater than 1")
                var altAnsTextArr = altAnsText.split(';');
                var lastPosOfImg = 0
                for (var j = 0; j <= altAnsTextArr.length - 1; j = j + 2) {
                  lastPosOfImg = tempDisplayAnwserText.indexOf("<img", lastPosOfImg)
                  lastPosOfImg = lastPosOfImg + 4
                  var b = "  title =\"" + altAnsTextArr[j] + "\"  alt =\"" + altAnsTextArr[j + 1] + "\" "
                  var output = [tempDisplayAnwserText.slice(0, lastPosOfImg), b, tempDisplayAnwserText.slice(lastPosOfImg)].join('');
                  tempDisplayAnwserText = output
                }
              }
            }
            tempDisplayAnswerArr[i].answer_text = tempDisplayAnwserText
            console.debug("tempDisplayAnswerArr[i]>>", tempDisplayAnswerArr[i])
            tempDisplayAnswerArr[i].isChecked = false
          }

        }
      } catch (e) {
        console.debug("ERROR in Alt answer Text and feedback ", e)
      }

    }
    console.debug("tempDisplayAnswerArr>>>>", tempDisplayAnswerArr)
    return tempDisplayAnswerArr ? tempDisplayAnswerArr : []
    // END

  }


  getCurrentVariableMapFromQuestion = (question, answerArr) => {
    let tempVariableMap;
    if (question.question_type === 1 && question.answer_type !== 2) {
      let tempDisplayAnswerArr = answerArr;
      if (tempDisplayAnswerArr === null || tempDisplayAnswerArr === undefined) {
        tempDisplayAnswerArr = [];
      }
      const AnswerArr = [...tempDisplayAnswerArr];
      tempVariableMap = MathParserUtil.buildQuestionVariablesMap(question.question_variables);
      if (tempVariableMap && tempVariableMap.isValid()) {
        tempVariableMap.generateValues();
        let RPAnswerArr = MathParserUtil.stringToValueRPAnswer(AnswerArr, tempVariableMap)
        let shouldRandomize = false;
        let firstAttempt = true;
        let i = 0;
        do {
          if (firstAttempt) {
            shouldRandomize = MathParserUtil.shouldRandomize(RPAnswerArr);
          }
          if (shouldRandomize) {
            tempVariableMap.generateValues();
          }
          RPAnswerArr = MathParserUtil.stringToValueRPAnswer(AnswerArr, tempVariableMap)
          shouldRandomize = MathParserUtil.shouldRandomize(RPAnswerArr);
          firstAttempt = false;
          i++;
          //For Avoid Crashing
          if (i >= 10) {
            console.log("Randomized Continously.. Crash State..")
            break;
          }
        } while (shouldRandomize);
      }
    }
    return tempVariableMap;
  }

  shuffle(arra1) {
    if (arra1) {
      var ctr = arra1.length, temp, index;

      // While there are elements in the array
      while (ctr > 0) {
        // Pick a random index
        index = Math.floor(Math.random() * ctr);
        // Decrease ctr by 1
        ctr--;
        // And swap the last element with it
        temp = arra1[ctr];
        arra1[ctr] = arra1[index];
        arra1[index] = temp;
      }
    }
    return arra1;
  }




  CheckAnswerTextForQuestion = function (selectedAnswer, mainQA) {
    let listkey = '';
    let listexpectedAnswer = '';
    let listinputAnswer = '';
    let currentQuestion = mainQA.question;

    console.log("CheckAnswerText", currentQuestion);
    const { answerDisplayStyle, question_type, answer_type, answer_formula } = currentQuestion;

    //vector Question with RP float answer type
    if (answer_type === 3 && question_type === 3 && answerDisplayStyle === 1 &&
      !(answer_formula?.formulaOneEvaluateOption === 0 && !answer_formula?.addFormulaSwitch)
    ) {
      let isCorrectAnswer = false
      let isCorrectAnswerFormulaOne = false;
      let isCorrectAnswerFormulaTwo = false;
      const FormulaOneCondition = answer_formula?.formulaOneEvaluateOption;
      const FormulaOne =answer_formula?.formula;
      const FormulaWithoutBrackets = FormulaOne ? FormulaOne.replace("{{", "").replace("}}", "") : "";
      const QueryOption = answer_formula?.formulaqueryOption;
      const FormulaTwoCondition = answer_formula?.formulaTwoEvaluateOption;
      const FormulaTwo = answer_formula?.formulaTwo;
      const FormulaTwoSwitch = answer_formula?.addFormulaSwitch;
      
      isCorrectAnswerFormulaOne = MathParserUtil.EvaluateAnswerWithQueryOptions(FormulaOne, 
        mainQA.tempVectorsVarMap,FormulaOneCondition,parseFloat(selectedAnswer[FormulaWithoutBrackets]))
        //console.log("Vector answer Range----------_>rp3",isCorrectAnswerFormulaOne)

      if(FormulaTwoSwitch) {
        isCorrectAnswerFormulaTwo = MathParserUtil.EvaluateAnswerWithQueryOptions(FormulaTwo, 
          mainQA.tempVectorsVarMap,FormulaTwoCondition,parseFloat(selectedAnswer[FormulaWithoutBrackets]))
          //console.log("Vector answer Range----------_>rp4",isCorrectAnswerFormulaTwo)
        if (QueryOption == 0 ) {
          //AND operator
          isCorrectAnswer = isCorrectAnswerFormulaOne && isCorrectAnswerFormulaTwo;
        } else if (QueryOption == 1) {
            //OR operator
            isCorrectAnswer = isCorrectAnswerFormulaOne || isCorrectAnswerFormulaTwo;
        }
      } else {
        isCorrectAnswer = isCorrectAnswerFormulaOne
      }
      return isCorrectAnswer                 
   
    }

     //vector Question with RP scifi notion answer type
     if (answer_type === 3 && question_type === 3 && answerDisplayStyle === 2 &&
      !(answer_formula?.formulaOneEvaluateOption === 0 && !answer_formula?.addFormulaSwitch)
    ) {
      //console.log("Vector answer Range----------_>formulaArray",answer_formula)
      let isCorrectAnswer = false
      let isCorrectAnswerFormulaOne = false;
      let isCorrectAnswerFormulaTwo = false;
      const FormulaOneCondition = answer_formula?.formulaOneEvaluateOption;
      const FormulaOne =answer_formula?.formula;
      const FormulaWithoutBrackets = FormulaOne ? FormulaOne.replace("{{", "").replace("}}", "") : "";
      const QueryOption = answer_formula?.formulaqueryOption;
      const FormulaTwoCondition = answer_formula?.formulaTwoEvaluateOption;
      const FormulaTwo = answer_formula?.formulaTwo;
      const FormulaTwoSwitch = answer_formula?.addFormulaSwitch;
      const inputAnswer = parseFloat(selectedAnswer[FormulaWithoutBrackets]);
      
      isCorrectAnswerFormulaOne = MathParserUtil.EvaluateAnswerWithQueryOptions(FormulaOne, 
        mainQA.tempVectorsVarMap,FormulaOneCondition,parseFloat(selectedAnswer[FormulaWithoutBrackets]))
        //console.log("Vector answer Range----------_>rp3",isCorrectAnswerFormulaOne,inputAnswer)

      if(FormulaTwoSwitch) {
        isCorrectAnswerFormulaTwo = MathParserUtil.EvaluateAnswerWithQueryOptions(FormulaTwo, 
          mainQA.tempVectorsVarMap,FormulaTwoCondition,parseFloat(selectedAnswer[FormulaWithoutBrackets]))
          //console.log("Vector answer Range----------_>rp4",isCorrectAnswerFormulaTwo)
        if (QueryOption == 0 ) {
          //AND operator
          isCorrectAnswer = isCorrectAnswerFormulaOne && isCorrectAnswerFormulaTwo;
        } else if (QueryOption == 1) {
            //OR operator
            isCorrectAnswer = isCorrectAnswerFormulaOne || isCorrectAnswerFormulaTwo;
        }
      } else {
        isCorrectAnswer = isCorrectAnswerFormulaOne
      }
      return isCorrectAnswer                 
   
    }

    if (answer_type === 3  || answer_type === 90) {
      const { formulaArray } = answer_formula;
      if (formulaArray && formulaArray.length > 0) {

        for (var index = 0; index < formulaArray.length; index++) {
          const { validationMode, text, ...rest } = formulaArray[index];
          const textWithoutBrackets = text ? text.replace("{{", "").replace("}}", "") : "";
          console.debug("validationMode and currentQuestion", validationMode, currentQuestion, mainQA.currentVariableMap, mainQA.tempVectorsVarMap, text)
          switch (validationMode) {
            case 'valueRange':
              {
                const { absAccuracyValue } = rest;
                // const correctAnswer = MathParserUtil.computeAnswer(text, mainQA.currentVariableMap);
                let correctAnswer = 0;
                if (currentQuestion.question_type === 3 && currentQuestion.answer_type === 3) {
                  correctAnswer = MathParserUtil.computeAnswer(text, mainQA.tempVectorsVarMap)
                } else {
                  correctAnswer = MathParserUtil.computeAnswer(text, mainQA.currentVariableMap);
                }
                const lowerRange = correctAnswer - parseFloat(absAccuracyValue);
                const upperRange = correctAnswer + parseFloat(absAccuracyValue);
                const inputAnswer = parseFloat(selectedAnswer[textWithoutBrackets]);
                if (lowerRange <= inputAnswer && inputAnswer <= upperRange) {
                  console.log("correct answer");

                } else {
                  return false;
                }
                break;
              }
            case 'precision':
              const { answerPrecision } = rest;
              // const correctAnswer = MathParserUtil.computeAnswer(text, this.state.currentVariableMap);
              let correctAnswer = 0;
              if (currentQuestion.question_type === 3 && currentQuestion.answer_type === 3) {
                correctAnswer = MathParserUtil.computeAnswer(text, mainQA.tempVectorsVarMap)
              } else {
                correctAnswer = MathParserUtil.computeAnswer(text, mainQA.currentVariableMap);
              }
              const expectedAnswer = correctAnswer.toPrecision(answerPrecision);
              const inputAnswer = parseFloat(selectedAnswer[textWithoutBrackets]).toPrecision(answerPrecision);
              if (expectedAnswer === inputAnswer) {
                console.log("correct answer");
              } else {
                return false;
              }
              break;
            case 'list':
              {
                let isEnteredAnswerCorrect = false;
                const { listValues } = rest;
                const { isCaseSensitive } = rest;
                const { shouldAnswerAll } = rest;
                listkey = mainQA.currentVariableMap.get(textWithoutBrackets).value;
                listexpectedAnswer = listValues[listkey];
                listinputAnswer = selectedAnswer[textWithoutBrackets];
                switch (answerDisplayStyle) {
                  case 1: // decimal type answer format
                    if (listexpectedAnswer.includes(',')) {
                      expectedAnswers = listexpectedAnswer.split(',');
                      for (const expectedAnswer of expectedAnswers) {
                        if (expectedAnswer.toLowerCase().trim() === listinputAnswer.toLowerCase().trim()) {
                          isEnteredAnswerCorrect = true;
                          break;
                        }
                      }
                    }
                    else { // check when expected answers dont have comma
                      if (listexpectedAnswer.toLowerCase().trim() === listinputAnswer.toLowerCase().trim()) {
                        isEnteredAnswerCorrect = true;
                      }
                    }
                    break;
                  case 4:  // text type answer format
                    let enteredAnswers = [];
                    let expectedAnswers = [];
                    let answer;
                    if (listexpectedAnswer.includes(',')) {
                      expectedAnswers = listexpectedAnswer.split(',');
                    }
                    else {
                      expectedAnswers.push(listexpectedAnswer);
                    }
                    if (listinputAnswer.includes(',')) {
                      enteredAnswers = listinputAnswer.split(',');  // more than one answer entered
                    }
                    else {
                      enteredAnswers.push(listinputAnswer); // if only one answer enetered
                    }
                    // check conditions for case sensitive and case insensitive
                    for (let enteredAnswer of enteredAnswers) {
                      if (isCaseSensitive) {
                        answer = enteredAnswer.trim();
                        enteredAnswers[enteredAnswers.indexOf(enteredAnswer)] = answer;
                      }
                      else if (isCaseSensitive === false) {
                        answer = enteredAnswer.trim();
                        answer = answer.toLowerCase();
                        enteredAnswers[enteredAnswers.indexOf(enteredAnswer)] = answer;
                      }
                    }
                    for (let expectedAnswer of expectedAnswers) {
                      if (isCaseSensitive) {
                        answer = expectedAnswer.trim();
                        expectedAnswers[expectedAnswers.indexOf(expectedAnswer)] = answer;
                      }
                      else if (isCaseSensitive === false) {
                        answer = expectedAnswer.trim();
                        answer = answer.toLowerCase();
                        expectedAnswers[expectedAnswers.indexOf(expectedAnswer)] = answer;
                      }
                    }
                    // check conditions for answer all or any and verify accordingly
                    for (let expectedAnswer of expectedAnswers) {
                      if (shouldAnswerAll === false) {
                        if (enteredAnswers.includes(expectedAnswer)) {  // verify one expected answer is found in entered answer
                          isEnteredAnswerCorrect = true;     // if yes then answer is correct
                          break;
                        }
                      }
                      else if (shouldAnswerAll === true) {
                        if (enteredAnswers.includes(expectedAnswer)) {  // checks each expected answer is found in entered answer
                          isEnteredAnswerCorrect = true;
                        }
                        else {
                          isEnteredAnswerCorrect = false;   // else if any one is not found then it stops remaining verification and regards as incorrect
                          break;
                        }
                      }
                    }
                    break;
                }
                // check correct flag
                if (isEnteredAnswerCorrect) {
                  return true;
                } else {
                  return false;
                }
              }
            default:
              {
                const { accuracyRange } = rest;
                // const correctAnswer = MathParserUtil.computeAnswer(text, this.state.currentVariableMap);

                let correctAnswer = 0;
                if (question_type === 3 && answer_type === 3 || (question_type === 0 && answer_type === 90)) {
                  correctAnswer = MathParserUtil.computeAnswer(text, mainQA.tempVectorsVarMap)
                } else {
                  correctAnswer = MathParserUtil.computeAnswer(text, mainQA.currentVariableMap)
                }

                const acceptedDeviationValue = Math.abs(correctAnswer * (accuracyRange / 100));
                const lowerRange = correctAnswer - acceptedDeviationValue;
                const upperRange = correctAnswer + acceptedDeviationValue;

                const inputAnswer = parseFloat(selectedAnswer[textWithoutBrackets]);
                if (lowerRange <= inputAnswer && inputAnswer <= upperRange) {
                  console.log("correct answer");
                } else {
                  return false;
                }
              }
          }
        }
      }
    }
    
    return true;
  }

  CheckAnswerText = function (selectedAnswer, currentQuestion) {
    let listkey = '';
    let listexpectedAnswer = '';
    let listinputAnswer = '';

    console.log("CheckAnswerText", currentQuestion);
    const { answerDisplayStyle, answer_type, answer_formula } = currentQuestion;

    //vector Question with RP float answer type
    if (answer_type === 3 && this.state.currentQuestionType === 3 && answerDisplayStyle === 1 &&
      !(answer_formula?.formulaOneEvaluateOption === 0 && !answer_formula?.addFormulaSwitch)
    ) {
      let isCorrectAnswer = false
      let isCorrectAnswerFormulaOne = false;
      let isCorrectAnswerFormulaTwo = false;
      const FormulaOneCondition = answer_formula?.formulaOneEvaluateOption;
      const FormulaOne =answer_formula?.formula;
      const FormulaWithoutBrackets = FormulaOne ? FormulaOne.replace("{{", "").replace("}}", "") : "";
      const QueryOption = answer_formula?.formulaqueryOption;
      const FormulaTwoCondition = answer_formula?.formulaTwoEvaluateOption;
      const FormulaTwo = answer_formula?.formulaTwo;
      const FormulaTwoSwitch = answer_formula?.addFormulaSwitch;
      
      isCorrectAnswerFormulaOne = MathParserUtil.EvaluateAnswerWithQueryOptions(FormulaOne, 
        this.state.currentVectorVariable,FormulaOneCondition,parseFloat(selectedAnswer[FormulaWithoutBrackets]))
        //console.log("Vector answer Range----------_>rp3",isCorrectAnswerFormulaOne)

      if(FormulaTwoSwitch) {
        isCorrectAnswerFormulaTwo = MathParserUtil.EvaluateAnswerWithQueryOptions(FormulaTwo, 
          this.state.currentVectorVariable,FormulaTwoCondition,parseFloat(selectedAnswer[FormulaWithoutBrackets]))
          //console.log("Vector answer Range----------_>rp4",isCorrectAnswerFormulaTwo)
        if (QueryOption == 0 ) {
          //AND operator
          isCorrectAnswer = isCorrectAnswerFormulaOne && isCorrectAnswerFormulaTwo;
        } else if (QueryOption == 1) {
            //OR operator
            isCorrectAnswer = isCorrectAnswerFormulaOne || isCorrectAnswerFormulaTwo;
        }
      } else {
        isCorrectAnswer = isCorrectAnswerFormulaOne
      }
      return isCorrectAnswer                 
   
    }

     //vector Question with RP scifi notion answer type
     if (answer_type === 3 && this.state.currentQuestionType === 3 && answerDisplayStyle === 2 &&
      !(answer_formula?.formulaOneEvaluateOption === 0 && !answer_formula?.addFormulaSwitch)
    ) {
      //console.log("Vector answer Range----------_>formulaArray",answer_formula)
      let isCorrectAnswer = false
      let isCorrectAnswerFormulaOne = false;
      let isCorrectAnswerFormulaTwo = false;
      const FormulaOneCondition = answer_formula?.formulaOneEvaluateOption;
      const FormulaOne =answer_formula?.formula;
      const FormulaWithoutBrackets = FormulaOne ? FormulaOne.replace("{{", "").replace("}}", "") : "";
      const QueryOption = answer_formula?.formulaqueryOption;
      const FormulaTwoCondition = answer_formula?.formulaTwoEvaluateOption;
      const FormulaTwo = answer_formula?.formulaTwo;
      const FormulaTwoSwitch = answer_formula?.addFormulaSwitch;
      const inputAnswer = parseFloat(selectedAnswer[FormulaWithoutBrackets]);
      
      isCorrectAnswerFormulaOne = MathParserUtil.EvaluateAnswerWithQueryOptions(FormulaOne, 
        this.state.currentVectorVariable,FormulaOneCondition,parseFloat(selectedAnswer[FormulaWithoutBrackets]))
        //console.log("Vector answer Range----------_>rp3",isCorrectAnswerFormulaOne,inputAnswer)

      if(FormulaTwoSwitch) {
        isCorrectAnswerFormulaTwo = MathParserUtil.EvaluateAnswerWithQueryOptions(FormulaTwo, 
          this.state.currentVectorVariable,FormulaTwoCondition,parseFloat(selectedAnswer[FormulaWithoutBrackets]))
          //console.log("Vector answer Range----------_>rp4",isCorrectAnswerFormulaTwo)
        if (QueryOption == 0 ) {
          //AND operator
          isCorrectAnswer = isCorrectAnswerFormulaOne && isCorrectAnswerFormulaTwo;
        } else if (QueryOption == 1) {
            //OR operator
            isCorrectAnswer = isCorrectAnswerFormulaOne || isCorrectAnswerFormulaTwo;
        }
      } else {
        isCorrectAnswer = isCorrectAnswerFormulaOne
      }
      return isCorrectAnswer                 
   
    }

    if (answer_type === 3  || answer_type === 90) {
      const { formulaArray } = answer_formula;
      if (formulaArray && formulaArray.length > 0) {

        for (var index = 0; index < formulaArray.length; index++) {
          const { validationMode, text, ...rest } = formulaArray[index];
          const textWithoutBrackets = text ? text.replace("{{", "").replace("}}", "") : "";
          console.debug("validationMode", validationMode, this.state.currentVariableMap, this.state.currentVectorVariable)
          switch (validationMode) {
            case 'valueRange':
              {
                const { absAccuracyValue } = rest;
                // const correctAnswer = MathParserUtil.computeAnswer(text, this.state.currentVariableMap);
                let correctAnswer = 0;
                if (this.state.currentQuestionType === 3 && this.state.answerType === 3) {
                  correctAnswer = MathParserUtil.computeAnswer(text, this.state.currentVectorVariable)
                } else {
                  correctAnswer = MathParserUtil.computeAnswer(text, this.state.currentVariableMap);
                }
                const lowerRange = correctAnswer - parseFloat(absAccuracyValue);
                const upperRange = correctAnswer + parseFloat(absAccuracyValue);
                const selectedAnswerInput = selectedAnswer[textWithoutBrackets];
                if(answerDisplayStyle === 5){
                  //decimal only Evaluation
                  if (!checkIsDecimalOnly(selectedAnswerInput)) {
                    return false
                  }
                }

                if(answerDisplayStyle === 6){
                  //E Notation only Evaluation
                  if (!checkIsENotationOnly(selectedAnswerInput)) {
                    return false
                  }
                }

                 // SigFig option Enable answer type ( Dcimal,Enotaion and scifi Notation)
                if( [1, 2, 5, 6].includes(Number(answerDisplayStyle)) && answer_formula?.formulaSigFigOption === 1) {
                  //SigFigOption Enabled
                  let inputAnswerstr = selectedAnswer[textWithoutBrackets];
                  //Evaluate Sig fig Evaluation
                  let sigFigValue;
                  if (Number(answerDisplayStyle) === 2 ){// scifi Notation
                     const formulaTextArray = MathParserUtil.splitAnswerTextFormulaToArray(answer_formula.formula);   
                     formulaTextArray.map((ansSegment,index) =>{
                      if(this.state.selectedAnswerDetails[ansSegment] ){
                        sigFigValue = countSignificantFiguresForScifi(this.state.selectedAnswerDetails[ansSegment])
                      }
                     })
                  }else {
                    sigFigValue = countSignificantFigures(inputAnswerstr)
                  }
                  if (sigFigValue !== answer_formula?.formulaSigFigOptionValue){
                    return false
                  }
                }
                const inputAnswer = parseFloat(selectedAnswer[textWithoutBrackets]);
                if (lowerRange <= inputAnswer && inputAnswer <= upperRange) {
                  console.log("correct answer");

                } else {
                  return false;
                }
                break;
              }
            case 'precision':
              const { answerPrecision } = rest;
              // const correctAnswer = MathParserUtil.computeAnswer(text, this.state.currentVariableMap);
              let correctAnswer = 0;
              if (this.state.currentQuestionType === 3 && this.state.answerType === 3) {
                correctAnswer = MathParserUtil.computeAnswer(text, this.state.currentVectorVariable)
              } else {
                correctAnswer = MathParserUtil.computeAnswer(text, this.state.currentVariableMap);
              }
              const expectedAnswer = correctAnswer.toPrecision(answerPrecision);
              const selectedAnswerInput = selectedAnswer[textWithoutBrackets];

              if(answerDisplayStyle === 5){
                //decimal only Evaluation
                if (!checkIsDecimalOnly(selectedAnswerInput)) {
                  return false
                }
              }

              if(answerDisplayStyle === 6){
                //E Notation only Evaluation
                if (!checkIsENotationOnly(selectedAnswerInput)) {
                  return false
                }
              }
              // SigFig option Enable answer type ( Dcimal,Enotaion and scifi Notation)
              if( [1, 2, 5, 6].includes(Number(answerDisplayStyle)) && answer_formula?.formulaSigFigOption === 1) {
                //SigFigOption Enabled
                let inputAnswerstr = selectedAnswer[textWithoutBrackets];
                //Evaluate Sig fig Evaluation
                let sigFigValue;
                if (Number(answerDisplayStyle) === 2 ){// scifi Notation
                   const formulaTextArray = MathParserUtil.splitAnswerTextFormulaToArray(answer_formula.formula);   
                   formulaTextArray.map((ansSegment,index) =>{
                    if(this.state.selectedAnswerDetails[ansSegment] ){
                      sigFigValue = countSignificantFiguresForScifi(this.state.selectedAnswerDetails[ansSegment])
                    }
                   })
                }else {
                  sigFigValue = countSignificantFigures(inputAnswerstr)
                }
                if (sigFigValue !== answer_formula?.formulaSigFigOptionValue){
                  return false
                }
              }
              const inputAnswer = parseFloat(selectedAnswer[textWithoutBrackets]).toPrecision(answerPrecision);
              if (expectedAnswer === inputAnswer) {
                console.log("correct answer");
              } else {
                return false;
              }
              break;
            case 'list':
              {
                let isEnteredAnswerCorrect = false;
                const { listValues } = rest;
                const { isCaseSensitive } = rest;
                const { shouldAnswerAll } = rest;
                listkey = this.state.currentVariableMap.get(textWithoutBrackets).value;
                listexpectedAnswer = listValues[listkey];
                listinputAnswer = selectedAnswer[textWithoutBrackets];
                switch (answerDisplayStyle) {
                  case 1: // decimal type answer format
                    if (listexpectedAnswer.includes(',')) {
                      expectedAnswers = listexpectedAnswer.split(',');
                      for (const expectedAnswer of expectedAnswers) {
                        if (expectedAnswer.toLowerCase().trim() === listinputAnswer.toLowerCase().trim()) {
                          isEnteredAnswerCorrect = true;
                          break;
                        }
                      }
                    }
                    else { // check when expected answers dont have comma
                      if (listexpectedAnswer.toLowerCase().trim() === listinputAnswer.toLowerCase().trim()) {
                        isEnteredAnswerCorrect = true;
                      }
                    }
                    break;
                  case 4:  // text type answer format
                    let enteredAnswers = [];
                    let expectedAnswers = [];
                    let answer;
                    if (listexpectedAnswer.includes(',')) {
                      expectedAnswers = listexpectedAnswer.split(',');
                    }
                    else {
                      expectedAnswers.push(listexpectedAnswer);
                    }
                    if (listinputAnswer.includes(',')) {
                      enteredAnswers = listinputAnswer.split(',');  // more than one answer entered
                    }
                    else {
                      enteredAnswers.push(listinputAnswer); // if only one answer enetered
                    }
                    // check conditions for case sensitive and case insensitive
                    for (let enteredAnswer of enteredAnswers) {
                      if (isCaseSensitive) {
                        answer = enteredAnswer.trim();
                        enteredAnswers[enteredAnswers.indexOf(enteredAnswer)] = answer;
                      }
                      else if (isCaseSensitive === false) {
                        answer = enteredAnswer.trim();
                        answer = answer.toLowerCase();
                        enteredAnswers[enteredAnswers.indexOf(enteredAnswer)] = answer;
                      }
                    }
                    for (let expectedAnswer of expectedAnswers) {
                      if (isCaseSensitive) {
                        answer = expectedAnswer.trim();
                        expectedAnswers[expectedAnswers.indexOf(expectedAnswer)] = answer;
                      }
                      else if (isCaseSensitive === false) {
                        answer = expectedAnswer.trim();
                        answer = answer.toLowerCase();
                        expectedAnswers[expectedAnswers.indexOf(expectedAnswer)] = answer;
                      }
                    }
                    // check conditions for answer all or any and verify accordingly
                    for (let expectedAnswer of expectedAnswers) {
                      if (shouldAnswerAll === false) {
                        if (enteredAnswers.includes(expectedAnswer)) {  // verify one expected answer is found in entered answer
                          isEnteredAnswerCorrect = true;     // if yes then answer is correct
                          break;
                        }
                      }
                      else if (shouldAnswerAll === true) {
                        if (enteredAnswers.includes(expectedAnswer)) {  // checks each expected answer is found in entered answer
                          isEnteredAnswerCorrect = true;
                        }
                        else {
                          isEnteredAnswerCorrect = false;   // else if any one is not found then it stops remaining verification and regards as incorrect
                          break;
                        }
                      }
                    }
                    break;
                }
                // check correct flag
                if (isEnteredAnswerCorrect) {
                  return true;
                } else {
                  return false;
                }
              }
            default:
              {
                const { accuracyRange } = rest;
                // const correctAnswer = MathParserUtil.computeAnswer(text, this.state.currentVariableMap);

                let correctAnswer = 0;
                if (this.state.currentQuestionType === 3 && this.state.answerType === 3 || (this.state.currentQuestionType === 0 && this.state.answerType === 90)) {
                  correctAnswer = MathParserUtil.computeAnswer(text, this.state.currentVectorVariable)
                } else {
                  correctAnswer = MathParserUtil.computeAnswer(text, this.state.currentVariableMap)
                }

                const acceptedDeviationValue = Math.abs(correctAnswer * (accuracyRange / 100));
                const lowerRange = correctAnswer - acceptedDeviationValue;
                const upperRange = correctAnswer + acceptedDeviationValue;
                const selectedAnswerInput = selectedAnswer[textWithoutBrackets];

                if(answerDisplayStyle === 5){
                  //decimal only Evaluation
                  if (!checkIsDecimalOnly(selectedAnswerInput)) {
                    return false
                  }
                }

                if(answerDisplayStyle === 6){
                  //E Notation only Evaluation
                  if (!checkIsENotationOnly(selectedAnswerInput)) {
                    return false
                  }
                }
                // SigFig option Enable answer type ( Dcimal,Enotaion and scifi Notation)
                if( [1, 2, 5, 6].includes(Number(answerDisplayStyle)) && answer_formula?.formulaSigFigOption === 1) {
                    //SigFigOption Enabled
                    let inputAnswerstr = selectedAnswer[textWithoutBrackets];
                    //Evaluate Sig fig Evaluation
                    let sigFigValue;
                    if (Number(answerDisplayStyle) === 2 ){// scifi Notation
                       const formulaTextArray = MathParserUtil.splitAnswerTextFormulaToArray(answer_formula.formula);   
                       formulaTextArray.map((ansSegment,index) =>{
                        if(this.state.selectedAnswerDetails[ansSegment] ){
                          sigFigValue = countSignificantFiguresForScifi(this.state.selectedAnswerDetails[ansSegment])
                        }
                       })
                    }else {
                      sigFigValue = countSignificantFigures(inputAnswerstr)
                    }
                    if (sigFigValue !== answer_formula?.formulaSigFigOptionValue){
                      return false
                    }
                }
                const inputAnswer = parseFloat(selectedAnswer[textWithoutBrackets]);
                if (lowerRange <= inputAnswer && inputAnswer <= upperRange) {
                  console.log("correct answer");
                } else {
                  return false;
                }
              }
          }
        }
      }
    }
    
    return true;
  }

  CheckAnswerRadio = function (selectedAnswer, currentQuestion) {
    let correctAnswerID = [];
    /*if (parseInt(selectedAnswer,10)  === currentQuestion.answers[1].answer_id)
      return true*/
    for (let index = 0; index < currentQuestion.answers.length; index++) {
      const answer = currentQuestion.answers[index];
      if (answer.is_answer) {
        correctAnswerID.push(answer.answer_id);
      }
    }

    if (correctAnswerID.includes(parseInt(selectedAnswer, 10))) {
      return true;
    }
    return false;
  }

  CheckAnswerCheckBox = function (selectedAnswer, currentQuestion) {
    var choiceSelected = false;
    if (selectedAnswer === undefined || selectedAnswer.length === 0)
      return false;
    let answers = currentQuestion.answers;
    let AllQuestionMustBeCorrect = (currentQuestion.for_checkbox_question == 1 ? true : false);
    var correctAnswerCount = 0;
    var selectedAnswerCount = 0;
    /*if(answers[1].answer_id  === parseInt(selectedAnswer[1],10))
      return true*/

    for (let index = 0; index < answers.length; index++) {
      var answer = answers[index];

      if (answer.is_answer) {
        correctAnswerCount++;
        for (let index1 = 0; index1 < selectedAnswer.length; index1++) {
          var choice = parseInt(selectedAnswer[index1], 10);
          if (answer.answer_id === choice) {
            choiceSelected = true;
            selectedAnswerCount++;
            break;
          }
          // else
          // {
          //   return false;
          // }

          // if(!choiceSelected)
          //   return false;
        }

      }
    }
    if (AllQuestionMustBeCorrect) {
      if (correctAnswerCount !== 0 && selectedAnswerCount !== 0 && selectedAnswer.length !== 0
        && correctAnswerCount === selectedAnswerCount && selectedAnswer.length === correctAnswerCount) {
        return true;
      } else {
        return false;
      }
    } else {
      if (correctAnswerCount !== 0 && selectedAnswerCount !== 0 && selectedAnswer.length !== 0
        && selectedAnswerCount > 0 && selectedAnswer.length === selectedAnswerCount) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }

  checkAnswerIsCorrectForQuestion(mainQA, answersMap) {
    let question = mainQA.question;
    let uniqueID = `${question.subject_id}_${question.topic_id}_${question.category_id}_${question.subcategory_id}_${question.question_id}`; 
    if (question.question_nongraded) {
      return true;
    }
    let isCorrectAnswer = false;
    
    let selectedAnswer =  answersMap[uniqueID];

    const {
      vector_answer_formulas,
    } = question;
    const currentVectorVariable = mainQA.tempVectorsVarMap;
    const currentVectorSettings = mainQA.vectorSettingsData;
    if ((question.question_type === 3 && question.answer_type === 2)  || (question.question_type === 0 && question.answer_type === 90)) {
      if((question.question_type === 0 && question.answer_type === 90)){
        const {
          vector_answer_formulas,
        } = question;
        let tempVectorVariable = vector_answer_formulas.filter(
          (vector) => !vector?.isStaticVector && !vector?.isIncorrectAnswer
        );
        let vectorVariable = VectorParser.buildQuestionVariablesMap(tempVectorVariable)

        let isIncorrectAnswer
        let tempIncorrectVectorVariable = vector_answer_formulas.filter(vector => vector?.isIncorrectAnswer);
        const filteredAnswer = Object.keys(selectedAnswer)
        .filter(key => {
            const vector = selectedAnswer[key];
            return !vector?.isStaticVector && !vector?.isIncorrectAnswer;
        })
        .reduce((result, key, index) => {
            result[index] = selectedAnswer[key];
            return result;
        }, {});

    
        if (tempIncorrectVectorVariable.length > 0) {
            const selectedAnsKeys = Object.keys(selectedAnswer);
            const selectedAnsSet = new Set(selectedAnsKeys.map(key => selectedAnswer[key]?.name));
            // Check if any incorrect vector's name exists in the selected answers
            for (const vector of tempIncorrectVectorVariable) {
                if (selectedAnsSet.has(vector.name)) {
                    isIncorrectAnswer = true;
                    break; // Exit if incorrect answer is selected
                }
            }
        }
        if(!isIncorrectAnswer) {

          isCorrectAnswer = VectorParser.isAnswerCorrect(tempVectorVariable, filteredAnswer, vectorVariable, this.state.currentVectorSettings);

        }else {
          isCorrectAnswer = false
        }
      }else {
        isCorrectAnswer = VectorParser.isAnswerCorrect(vector_answer_formulas, selectedAnswer, currentVectorVariable, currentVectorSettings);
      }
      console.debug("CONDITION = 1", question, isCorrectAnswer)

    } else if (question.question_type === 2) { // Multiple Question Grid
      console.debug("CONDITION = 2", question)
    } else {
      let answerType = question.answer_type;
      switch (answerType) {
        case 0:
        case 30:
        case 70:
        case 50:
          //Radio Button
          isCorrectAnswer = this.CheckAnswerRadio(selectedAnswer, question);
          break;
        case 1:
        case 40:
        case 80:
        case 60:
          //Check Box
          isCorrectAnswer = this.CheckAnswerCheckBox(selectedAnswer, question);
          break;
        case 2:
          //Text Box
          isCorrectAnswer = this.CheckAnswerTextForQuestion(selectedAnswer, mainQA);
          break;
        case 3:
          //RP Text Box
          isCorrectAnswer = this.CheckAnswerTextForQuestion(selectedAnswer, mainQA);
          break;
        default:
          //Invalid Answer Type
          isCorrectAnswer = false;
          break;
      }
      console.debug("CONDITION = 3", question, question.answer, isCorrectAnswer, selectedAnswer)
    }
    return isCorrectAnswer;
  }

  checkAnswerIsCorrect() {
    console.debug("checkAnswerIsCorrect():");
    var isCorrectAnswer = false;
    var tempQuestionID =  this.state.subject_id + "_" + this.state.topic_id + "_" + this.state.category_id  +  "_" +  this.state.subcategory_id + "_" + this.state.question_id;
    var tempSkillsMasterd = this.state.skillsMasterd;

    var tempCompletedCategoryArray = this.state.completedCategoryArray;
    var tempnumberOfCategories = this.state.numberOfCategories;
    var tempCategoriesMap = this.state.categoriesMap;
    var subCategoryQuestionMap = this.state.subCategoryQuestionMap;
    var categorySubcategoryMap = this.state.categorySubcategoryMap;

    var tempSubcategoriesMap = this.state.subcategoriesMap;
    var isNonGrade = false;
    if (tempSubcategoriesMap[this.state.randomSubCategory] !== undefined &&
      tempSubcategoriesMap[this.state.randomSubCategory] !== null) {

      if (tempSubcategoriesMap[this.state.randomSubCategory].non_graded === 1) {
        isNonGrade = true;
        isCorrectAnswer = true;
      }
    }

    var correctAnswerArray = null;
    var currentQuestion = null;
    var tempAnswerChoosen = null;
    var tempRandomCategory = null;
    var shouldWaitB4Update = false;
    console.log("checkAnswerIsCorrectsurveyQuestionsRetrieved = ", this.state.surveyQuestionsRetrieved);
    if (this.state.surveyQuestionsRetrieved === false) {
      //Question answer check


      correctAnswerArray = this.state.correctAnswerMap[tempQuestionID];
      currentQuestion = this.state.questionMap[tempQuestionID];
      tempAnswerChoosen = this.state.selectedAnswer;
      tempRandomCategory = this.state.randomCategory;



      if (currentQuestion.question_nongraded !== undefined &&
        currentQuestion.question_nongraded !== null) {

        if (currentQuestion.question_nongraded === 1) {
          isNonGrade = true;
          isCorrectAnswer = true;
        }
      }


      console.debug("tempRandomCategory = ", tempRandomCategory);

      console.debug("correctAnswerArray = ", correctAnswerArray);
      console.debug("this.state.randomQuestionID = ", this.state.randomQuestionID);
      console.debug("currentQuestion = ", currentQuestion);

      console.debug("tempAnswerChoosen = ", tempAnswerChoosen);

      //If Question Type is MQT 
      if (this.state.currentQuestionType === 3 && currentQuestion.answer_type === 2  || (this.state.currentQuestionType === 0 && currentQuestion.answer_type === 90)) {
        const {
          vector_answer_formulas,
        } = currentQuestion;
        const { currentVectorVariable, selectedAnswer } = this.state;
        if (isNonGrade === false) {
          if((this.state.currentQuestionType === 0 && currentQuestion.answer_type === 90)){
            const {
              vector_answer_formulas,
            } = currentQuestion;
            const { currentVectorVariable, selectedAnswer } = this.state;
            let tempVectorVariable = vector_answer_formulas.filter(
              (vector) => !vector?.isStaticVector && !vector?.isIncorrectAnswer
            );
            let vectorVariable = VectorParser.buildQuestionVariablesMap(tempVectorVariable)

            let isIncorrectAnswer
            let tempIncorrectVectorVariable = vector_answer_formulas.filter(vector => vector?.isIncorrectAnswer);
            const filteredAnswer = Object.keys(this.state.selectedAnswer)
            .filter(key => {
                const vector = this.state.selectedAnswer[key];
                return !vector?.isStaticVector && !vector?.isIncorrectAnswer;
            })
            .reduce((result, key, index) => {
                result[index] = this.state.selectedAnswer[key];
                return result;
            }, {});

        
            if (tempIncorrectVectorVariable.length > 0) {
                const selectedAnsKeys = Object.keys(this.state.selectedAnswer);
                const selectedAnsSet = new Set(selectedAnsKeys.map(key => this.state.selectedAnswer[key]?.name));
                // Check if any incorrect vector's name exists in the selected answers
                for (const vector of tempIncorrectVectorVariable) {
                    if (selectedAnsSet.has(vector.name)) {
                       isIncorrectAnswer = true;
                        break; // Exit if incorrect answer is selected
                    }
                }
            }
            if(!isIncorrectAnswer) {

              isCorrectAnswer = VectorParser.isAnswerCorrect(tempVectorVariable, filteredAnswer, vectorVariable, this.state.currentVectorSettings);

            }else {
              isCorrectAnswer = false
            }
          }else {
            isCorrectAnswer = VectorParser.isAnswerCorrect(vector_answer_formulas, selectedAnswer, currentVectorVariable, this.state.currentVectorSettings);
          }
        }
         
      } else if (this.state.currentQuestionType === 2) {
        if (isNonGrade === false)
          isCorrectAnswer = MQTOptions.isAnswerCorrect(this.state.mqt_options, this.state.selectedAnswer);
      } else {

        let answerType = currentQuestion.answer_type;
        if (isNonGrade === false) {
          switch (answerType) {
            case 0:
            case 30:
            case 70:
            case 50:
              //Radio Button
              isCorrectAnswer = this.CheckAnswerRadio(tempAnswerChoosen, currentQuestion);
              break;
            case 1:
            case 40:
            case 80:
            case 60:
              //Check Box
              isCorrectAnswer = this.CheckAnswerCheckBox(tempAnswerChoosen, currentQuestion);
              break;
            case 2:
              //Text Box
              isCorrectAnswer = this.CheckAnswerText(tempAnswerChoosen, currentQuestion);
              break;
            case 3:
              //RP Text Box
              isCorrectAnswer = this.CheckAnswerText(tempAnswerChoosen, currentQuestion);
              break;
            default:
              //Invalid Answer Type
              isCorrectAnswer = false;
              break;
          }
        }

      }


      if (isCorrectAnswer) {
        if (this.state.isTest !== 1) {
          //Quiz
          this.setState(
            {
              showAnswerResponse: true,
              answerCorrect: true,
              showSubmitLoader: false,
              tryAgainButtonDisplay: false,
            })
        }
      }
      else {
        //Wrong Answer
        this.setState({
          tryAgainButtonDisplay: false,
          displayCorrectAnswer: true,
          showAnswerResponse: true,
          answerCorrect: false,
          showSubmitLoader: false
        })
      }
      this.setState({ showSubmitLoader: false });
      return

    }


  }

  checkIfMQTAnswersSelectedForQuestion = (question, selectedAnswer) => {
    const { mqt_options } = question;

    if (mqt_options && selectedAnswer) {
      const { mqt_questions } = mqt_options;

      const questiondIDs = Object.keys(mqt_questions);
      for (const i in questiondIDs) {
        const qID = questiondIDs[i];
        if (selectedAnswer[qID]) {
          if (selectedAnswer[qID].length) {
            if (selectedAnswer[qID].length < 1) {
              return false;
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      }

      return true;
    }
    return false;
  }


  isMQTAnswersSelected = () => {
    const { mqt_options, selectedAnswer } = this.state;

    if (mqt_options && selectedAnswer) {
      const { mqt_questions } = mqt_options;

      const questiondIDs = Object.keys(mqt_questions);
      for (const i in questiondIDs) {
        const qID = questiondIDs[i];
        if (selectedAnswer[qID]) {
          if (selectedAnswer[qID].length) {
            if (selectedAnswer[qID].length < 1) {
              return false;
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      }

      return true;
    }
    return false;
  }

  async showAlert(title, msg, yesLabel, noLabel) {
    return new Promise((resolve, reject) => {
      confirmAlert({
        title: title,
        message: msg,
        buttons: [
          {
            label: yesLabel,
            onClick: () => {
              resolve(true); // Resolving with true if 'Submit' is clicked
            }
          },
          {
            label: noLabel,
            onClick: () => {
              resolve(false); // Resolving with false if 'Cancel' is clicked
            }
          }
        ],
      });
    });
  }


  async reasoningChainAnswerValidation() {

    if (this.state.currentQuestionType === 4) {
      let hasConclusionSentence = this.state.selectedAnswer.includes("C")

      if (this.state.isConclusionSentenceRequired && !hasConclusionSentence) { // if concl sent is required and not been selected
        NotificationManager.warning("You need to pick atleast one conclusion sentences.")
        return false;
      }

      if (!this.state.isConclusionSentenceRequired && !hasConclusionSentence) { // if concl sent is NOT required and not been selected
        const result = await this.showAlert("Gentle reminder", "You have not added a conclusion. Do you wish to continue submitting the question without adding a conclusion?", "Submit", "Cancel");
        if (!result) {
          return false;
        }
      }

      return true;
    }

    return true;
  }


  async onSubmitClick() {
    // clear all previous notifications
    NotificationManager.listNotify.forEach(n => NotificationManager.remove({ id: n.id }));

    if (this.state.currentQuestionType === 3 && this.state.answerType === 2 || (this.state.currentQuestionType === 0 && this.state.answerType === 90)) {
      var currentQuestion = null;
      var tempQuestionID = this.state.randomSubCategory + "_" + this.state.randomQuestionID;
      currentQuestion = this.state.questionMap[tempQuestionID];
    }

    console.debug("this.state.selectedAnswer =", this.state.selectedAnswer);
    console.debug("this.state.selectedAnswer =", this.state.selectedAnswer.length);
    if (this.state.currentQuestionType === 2) {
      console.debug("this.isMQTAnswersSelected()", this.isMQTAnswersSelected())
      if (!this.isMQTAnswersSelected()) {
        NotificationManager.warning(`Please choose an answer for each Question`, '', 3000)
        // alert("Please choose an answer for each Question");
        return;
      }
    }
    //console.log("onAnswerClick ",index)
    var tempQuestionID = this.state.subject_id + "_" + this.state.topic_id + "_" + this.state.category_id  +  "_" +  this.state.subcategory_id + "_" + this.state.question_id;

    const answerType = this.state.questionMap[tempQuestionID].answer_type

    let questID =tempQuestionID
    let quest = this.state.questionMap[questID];
    console.log('this.state>>>>>', this.state, quest);
    if (this.state.currentQuestionType !== 4) {
      if (!this.hasValidValue(this.state.selectedAnswer, quest)) {
        console.debug("answerType ", answerType)
        if (answerType !== undefined && answerType === 3) {
          NotificationManager.warning(`Please enter the answer`, '', 3000)
        } else {
          NotificationManager.warning(`Please choose an answer`, '', 3000)
        }
        return;
      }
    }


    // checking for reasoning chain answer validation
    if (this.state.currentQuestionType === 4) {
      let isValid = await this.reasoningChainAnswerValidation();
      if (!isValid) return;
    }


    if (answerType == 3 && !MathParserUtil.isAnswerSelected(this.state.answer_formula.formulaMap, this.state.selectedAnswer)) {
      NotificationManager.warning(`Please enter the answer in all boxes`, '', 3000)
      //alert("Please enter the answer in all boxes");
      return;
    }

    if (submitClickInProgress === false) {
      submitClickInProgress = true;
      this.setState({
        submitButtonDisplay: false,
        showSubmitLoader: true,
        hideNext: false
      }, () => {
        console.debug("On Submit Click");

        if (this.state.isTest === 1) {
          //this.setState({pageLoading:true});
          let isCorrectAnswer = false;
          if (this.state.currentQuestionType === 3 && this.state.answerType === 2 ) {
            const {
              vector_answer_formulas,
            } = currentQuestion;
            const { currentVectorVariable, selectedAnswer } = this.state;
            isCorrectAnswer = VectorParser.isAnswerCorrect(vector_answer_formulas, selectedAnswer, currentVectorVariable, this.state.currentVectorSettings);
          }
          if((this.state.currentQuestionType === 0 && this.state.answerType  === 90)){
            const {
              vector_answer_formulas,
            } = currentQuestion;
            const { currentVectorVariable, selectedAnswer } = this.state;
            let tempVectorVariable  = vector_answer_formulas.filter((vector)=> !vector?.isStaticVector && !vector?.isIncorrectAnswer)
            let vectorVariable = VectorParser.buildQuestionVariablesMap(tempVectorVariable)
            let isIncorrectAnswer
            let tempIncorrectVectorVariable = vector_answer_formulas.filter(vector => vector?.isIncorrectAnswer);
            const filteredAnswer = Object.keys(this.state.selectedAnswer)
            .filter(key => {
                const vector = this.state.selectedAnswer[key];
                return !vector?.isStaticVector && !vector?.isIncorrectAnswer;
            })
            .reduce((result, key, index) => {
                result[index] = this.state.selectedAnswer[key];
                return result;
            }, {});

            if (tempIncorrectVectorVariable.length > 0) {
              const selectedAnsKeys = Object.keys(this.state.selectedAnswer);
              const selectedAnsSet = new Set(selectedAnsKeys.map(key => this.state.selectedAnswer[key]?.name));
              // Check if any incorrect vector's name exists in the selected answers
              for (const vector of tempIncorrectVectorVariable) {
                  if (selectedAnsSet.has(vector.name)) {
                     isIncorrectAnswer = true;
                      break; // Exit if incorrect answer is selected
                  }
              }
          }
          if(!isIncorrectAnswer) {
            isCorrectAnswer = VectorParser.isAnswerCorrect(tempVectorVariable, filteredAnswer, vectorVariable, this.state.currentVectorSettings);
          }else {
            isCorrectAnswer = false
          }
          
          }
          console.log("isCorrect--------_>",isCorrectAnswer)
          // this.saveProgress(isCorrectAnswer);
          submitClickInProgress = false;
          this.setState({
            hideNext: true
          });
          /* var tempDate = this.getDateTime();
           const tempQuestionStartTimeStamp = MomentTz(tempDate).tz(timeZone).format("YYYY-MM-DD HH:mm:ss");
           console.debug("tempQuestionStartTimeStamp =",tempQuestionStartTimeStamp);
           this.questionStartTimeStamp =  tempQuestionStartTimeStamp;
           */
          return;
        }
        //Dummy Code, to be changed later
        console.debug("this.state.selectedAnswer = ", this.state.selectedAnswer);

        this.checkAnswerIsCorrect();
        submitClickInProgress = false;

      });
    }

    this.findFeedbackText(this.state.selectedAnswer, false);
    this.onFeedbackClick();  

  }



  onPrevClick() {
    var tempDisplayAnswerArr = this.state.displayAnswerArr;
    tempDisplayAnswerArr?.forEach((_, index) => {
      if (tempDisplayAnswerArr[index].isChecked) {
        tempDisplayAnswerArr[index].isChecked = false
      }
    })
    var tempTryAgainCount = this.state.tryAgainCount + 1;
    var tempQuestionAttempt = this.state.question_attempt + 1;
    //this.setState({displayAnswerArr:[],})
    this.setState({
      questionStartTime: new Date(),
      submitButtonDisplay: true,
      tryAgainButtonDisplay: false,
      showAnswerResponse: false,
      answerCorrect: false,
      displayAnswerArr:tempDisplayAnswerArr,
      tryAgainCount: tempTryAgainCount,
      forceUpdateHandler: true,
      //feedback & liveanalytics
      feedbackPopupVisible: false,
      feedbackOn: true,
      feedbackAnswer: null,
      feedbackButtonVisible: false,
      liveAnalyticsButtonVisible: false,
      liveAnalyticsPopup: false,
      displayCorrectAnswer: false,
      selectedAnswer: [],
      showMQTAnswers:false,
      alreadyPickedAnswer:[],
      explanationButtonDisplay: false,
      showRPAnswer: false,
      showVectorAnswer: false,
      question_attempt: tempQuestionAttempt,
      showWelcomeBackMsg: false,
      selectedAnswers:[],
      isCheckAnswerPressed: false,
    })

    let tempQuestionID = this.state.subject_id + "_" + this.state.topic_id + "_" + this.state.category_id  +  "_" +  this.state.subcategory_id + "_" + this.state.question_id;
    let question = this.state.questionMap[tempQuestionID];
    
    let payload = {
      unique_id: tempQuestionID,
      subject_id: question.subject_id,
      topic_id: question.topic_id,
      category_id: question.category_id,
      subcategory_id: question.subcategory_id,
      question_id: question.question_id,
      quiz_id: this.state.quizId,
      section_id: parseInt(this.params.get("section_id")),
      student_answer_string: "",
      update_student_answer: true,
      other_state_map_string: JSON.stringify({
        submitButtonDisplay: true,
        tryAgainButtonDisplay: false,
        showAnswerResponse: false,
        answerCorrect: false,
        tryAgainCount: tempTryAgainCount,
        forceUpdateHandler: true,
        feedbackPopupVisible: false,
        feedbackOn: true,
        feedbackAnswer: null,
        feedbackButtonVisible: false,
        liveAnalyticsButtonVisible: false,
        liveAnalyticsPopup: false,
        hideNext: false,
        displayCorrectAnswer: false,
        question_attempt: tempQuestionAttempt,
        explanationButtonDisplay: false,
        showRPAnswer: false,
        showVectorAnswer: false,
      })
    }


  }

  onExplanationClick() {
    console.debug("Explanation Clicked");
    if (this.state.explanationGalleryVisible == false) {

      this.setState({
        explanationGalleryVisible: true
      })
    } else {
      this.setState({
        explanationGalleryVisible: false
      })
    }

  }
  onFeedbackClick() {
    console.debug("quiz_id ", this.state.quizId);
    console.debug("feedback Clicked", this.state.liveAnalyticsPopup, this.state.feedbackAnswer);
    if (this.state.liveAnalyticsPopup == true) {
      this.setState({
        liveAnalyticsPopup: false,
        liveAnalyticsButtonVisible: true
      })
    }
    //if(this.state.feedbackButtonVisible==true){
    if (this.state.feedbackAnswer !== undefined && this.state.feedbackAnswer !== null) {
      this.setState({
        feedbackPopupVisible: true,
        feedbackButtonVisible: false
      })
      //}else{
      //this.setState({
      //feedbackPopupVisible:false
      //})}
    }
  }
  onFeedbackCloseClick() {
    this.setState({
      feedbackPopupVisible: false,
      feedbackButtonVisible: true
    })
  }

  onliveAnalyticsCloseClick() {
    this.setState({
      liveAnalyticsPopup: false,
      liveAnalyticsButtonVisible: true
    });
  }
  liveAnalyticsClick() {
    if (this.state.liveAnalytics.user_count !== undefined && this.state.liveAnalytics.user_count !== null) {
      if (this.state.liveAnalytics.user_count > 10) {
        this.setState({
          liveAnalyticsPopup: true,
          liveAnalyticsButtonVisible: false
        })
      } else {
        console.debug("usercount :", this.state.liveAnalytics.user_count)
        this.setState({
          liveAnalyticsPopup: false,
          liveAnalyticsButtonVisible: true
        })
        alert("Sorry less than 10 only answered this Question")
      }
    } else {

    }
    if (this.state.feedbackPopupVisible == true) {
      this.setState({
        feedbackButtonVisible: true,
        feedbackPopupVisible: false
      })
    }
  }


  findFeedbackText(selectedAns, avl) {
    var feedbackTxt = ""
    var currFeedbackAns = {}
    console.debug("selectedAns", selectedAns)
    var tempcurrentFeedbackSubCategory, tempfeedbackSubcategoryList, tempfeedbackCurrentQuestion;
    if (this.state.feedbackOn == true || avl == true) {
      tempcurrentFeedbackSubCategory = this.state.currentFeedbackSubCategory;
      tempfeedbackSubcategoryList = this.state.subcategoriesMap;
      tempfeedbackCurrentQuestion = this.state.currentPreviewQuestionData;
      
      console.debug("this.state.currentPreviewQuestionData ", this.state.currentPreviewQuestionData)
      console.debug("this the question details ", tempfeedbackCurrentQuestion)
      console.debug("this the tempfeedbackSubcategoryList details ", tempfeedbackSubcategoryList)
      console.debug("this the tempcurrentFeedbackSubCategory details ", tempcurrentFeedbackSubCategory)
      if (tempfeedbackCurrentQuestion && tempfeedbackCurrentQuestion.enable_feedback === true) {
        console.log("feedback enabled")
        if (selectedAns.constructor == Array) {
          for (let i = 0; i <= tempfeedbackCurrentQuestion.answers.length - 1; i++) {
            for (let j = 0; j <= selectedAns.length - 1; j++) {
              console.debug(i, j)
              if (tempfeedbackCurrentQuestion.answers[i].feedback_text !== undefined && tempfeedbackCurrentQuestion.answers[i].feedback_text !== null &&
                tempfeedbackCurrentQuestion.answers[i].feedback_text !== '') {
                if (tempfeedbackCurrentQuestion.answers[i].answer_id == selectedAns[j]) {
                  console.debug(tempfeedbackCurrentQuestion.answers[i].answer_id)
                  console.debug(tempfeedbackCurrentQuestion.answers[i].feedback_text)
                  try {
                    var tempFeed = TextEditor.getHTMLStringFromEditorState(EditorState.createWithContent(
                      convertFromRaw(JSON.parse(tempfeedbackCurrentQuestion.answers[i].feedback_text)))).toString('html', null);
                    console.debug("feedback ", tempFeed)
                    //alt feedback text
                    console.debug(tempfeedbackCurrentQuestion.answers[i].alt_feedback_text)
                    if (tempfeedbackCurrentQuestion.answers[i].alt_feedback_text !== undefined &&
                      tempfeedbackCurrentQuestion.answers[i].alt_feedback_text !== null &&
                      tempfeedbackCurrentQuestion.answers[i].alt_feedback_text !== "") {
                      console.debug("hello")
                      var tempDisplayFeedbackText = tempFeed
                      var altFeedbackText = tempfeedbackCurrentQuestion.answers[i].alt_feedback_text
                      altFeedbackText = altFeedbackText.replace(/\n/ig, ' ')
                      //finding number of time image present
                      var altFeedbackTextCount = altFeedbackText.split(';').length
                      var feedbackImgTagCount = tempDisplayFeedbackText.split('<img').length - 1
                      // console.debug("altFeedbackTextCount ,feedbackImgTagCount ",altFeedbackTextCount,feedbackImgTagCount,randomQuestion.answers.length-1)
                      console.debug((altFeedbackTextCount / 2), "==", feedbackImgTagCount)
                      if ((altFeedbackTextCount / 2) == feedbackImgTagCount) {
                        if (feedbackImgTagCount >= 1) {
                          console.debug("Answer greater than 1")
                          var altFeedbackTextArr = altFeedbackText.split(';');
                          var lastPosOfImg = 0
                          // console.debug("altanswer",altFeedbackTextArr)
                          for (var k = 0; k <= altFeedbackTextArr.length - 1; k = k + 2) {
                            // console.debug(j)
                            lastPosOfImg = tempDisplayFeedbackText.indexOf("<img", lastPosOfImg)
                            lastPosOfImg = lastPosOfImg + 4
                            var b = "  title =\"" + altFeedbackTextArr[k] + "\"  alt =\"" + altFeedbackTextArr[k + 1] + "\" "
                            var output = [tempDisplayFeedbackText.slice(0, lastPosOfImg), b, tempDisplayFeedbackText.slice(lastPosOfImg)].join('');
                            tempDisplayFeedbackText = output
                            console.debug("answertest", k, " ", tempDisplayFeedbackText)
                          }
                        }
                      }
                      tempFeed = tempDisplayFeedbackText
                    }
                    //alt feedback text
                  }
                  catch (err) {
                    console.error(err.message);
                  }
                  feedbackTxt = feedbackTxt.concat(tempFeed)
                  console.debug(feedbackTxt)
                }
              }
            }
          }
        } else {
          for (let i = 0; i <= tempfeedbackCurrentQuestion.answers.length - 1; i++) {
            if (tempfeedbackCurrentQuestion.answers[i].feedback_text !== undefined && tempfeedbackCurrentQuestion.answers[i].feedback_text !== null &&
              tempfeedbackCurrentQuestion.answers[i].feedback_text !== '') {
              console.debug(i)
              if (tempfeedbackCurrentQuestion.answers[i].answer_id == selectedAns) {
                console.debug(tempfeedbackCurrentQuestion.answers[i].answer_id)
                console.debug(tempfeedbackCurrentQuestion.answers[i].feedback_text)
                try {
                  var tempFeed = TextEditor.getHTMLStringFromEditorState(EditorState.createWithContent(
                    convertFromRaw(JSON.parse(tempfeedbackCurrentQuestion.answers[i].feedback_text)))).toString('html', null);
                  console.debug("feedback ", tempFeed)
                  //alt feedback text
                  console.debug(tempfeedbackCurrentQuestion.answers[i].alt_feedback_text)
                  if (tempfeedbackCurrentQuestion.answers[i].alt_feedback_text !== undefined &&
                    tempfeedbackCurrentQuestion.answers[i].alt_feedback_text !== null &&
                    tempfeedbackCurrentQuestion.answers[i].alt_feedback_text !== "") {
                    console.debug("hello")
                    var tempDisplayFeedbackText = tempFeed
                    var altFeedbackText = tempfeedbackCurrentQuestion.answers[i].alt_feedback_text
                    altFeedbackText = altFeedbackText.replace(/\n/ig, ' ')
                    //finding number of time image present
                    var altFeedbackTextCount = altFeedbackText.split(';').length
                    var feedbackImgTagCount = tempDisplayFeedbackText.split('<img').length - 1
                    // console.debug("altFeedbackTextCount ,feedbackImgTagCount ",altFeedbackTextCount,feedbackImgTagCount,randomQuestion.answers.length-1)
                    console.debug((altFeedbackTextCount / 2), "==", feedbackImgTagCount)
                    if ((altFeedbackTextCount / 2) == feedbackImgTagCount) {
                      if (feedbackImgTagCount >= 1) {
                        console.debug("Answer greater than 1")
                        var altFeedbackTextArr = altFeedbackText.split(';');
                        var lastPosOfImg = 0
                        // console.debug("altanswer",altFeedbackTextArr)
                        for (var j = 0; j <= altFeedbackTextArr.length - 1; j = j + 2) {
                          // console.debug(j)
                          lastPosOfImg = tempDisplayFeedbackText.indexOf("<img", lastPosOfImg)
                          lastPosOfImg = lastPosOfImg + 4
                          var b = "  title =\"" + altFeedbackTextArr[j] + "\"  alt =\"" + altFeedbackTextArr[j + 1] + "\" "
                          var output = [tempDisplayFeedbackText.slice(0, lastPosOfImg), b, tempDisplayFeedbackText.slice(lastPosOfImg)].join('');
                          tempDisplayFeedbackText = output
                          console.debug("answertest", j, " ", tempDisplayFeedbackText)
                        }
                      }
                    }
                    tempFeed = tempDisplayFeedbackText
                  }
                  //alt feedback text
                }
                catch (err) {
                  console.error(err.message);
                }
                feedbackTxt = feedbackTxt.concat(tempFeed)
                console.debug(feedbackTxt)

              }
            }
          }
        }
        console.debug("on findffeback ", feedbackTxt)
        if (feedbackTxt !== undefined && feedbackTxt !== null && feedbackTxt !== "") {

          console.debug("on findffeback ", feedbackTxt)

          if (feedbackTxt !== undefined && feedbackTxt !== null && feedbackTxt !== "") {
            this.setState({
              feedbackOn: false,
              feedbackPopupVisible: true,
              feedbackButtonVisible: false,
              feedbackAnswer: feedbackTxt
            });

          }
        }

      } else {
        console.log("feedback disables")
      }
    } else {
      console.log("feedback is false")
    }
    console.debug(this.state.feedbackAnswer)
  }

  appendExplanations(expArr, elem) {
    if (elem !== undefined &&
      elem !== null) {
      expArr = expArr.concat(elem);
      return { expArr: expArr, isAdded: true };
    }
    return { expArr: expArr, isAdded: false };
  }

  saveElapsedTimeForExplanations(startTimeMap, endTimeMap) {
    console.log("StartTime ", startTimeMap, " endTime ", endTimeMap);
    var explanationElapsedTimeArr = [];
    var elapsedTime = 0;
    for (let i = 0; i < this.state.explanations.length; i++) {
      var tempEndTimeArr = endTimeMap[i];
      var tempStartTimeArr = startTimeMap[i];
      if (tempEndTimeArr !== undefined && tempEndTimeArr !== null &&
        tempStartTimeArr !== undefined && tempStartTimeArr !== null) {
        for (let j = 0; j < tempEndTimeArr.length; j++) {
          elapsedTime += Math.round((Math.abs(tempEndTimeArr[j].getTime() - tempStartTimeArr[j].getTime())) / 1000);

        }
        explanationElapsedTimeArr.push({
          subject_id: this.state.explanations[i].subject_id,
          topic_id: this.state.explanations[i].topic_id,
          category_id: this.state.explanations[i].category_id,
          subcategory_id: this.state.explanations[i].subcategory_id,
          explanation_id: this.state.explanations[i].explanation_id,
          elapsed_time: elapsedTime
        });
        elapsedTime = 0;

      }
    }
    var idArr = this.state.randomSubCategory.split('_');

    var payload = {
      user_id: this.state.userId,
      quiz_id: this.state.quizId,
      question: {
        subject_id: parseInt(idArr[0]),
        topic_id: parseInt(idArr[1]),
        category_id: parseInt(idArr[2]),
        subcategory_id: parseInt(idArr[3]),
        question_id: this.state.randomQuestionID
      },
      elapsed_time: explanationElapsedTimeArr
    };

    console.log("the PAyload for elapsedTime is  ", payload);

  }

  getExplanationData = async () => {
    var is_topic_exp_needed = 0;
    var is_cat_exp_needed = 0;
    console.debug("Getting explantion information");
    var subCatUniqueID = this.state.randomSubCategory;
    if (this.state.randomCategory !== undefined && this.state.randomCategory !== null
      && this.state.randomSubCategory !== undefined && this.state.randomSubCategory !== null) {
      var idArr = this.state.randomSubCategory.split('_');
      var topic_id = idArr[0] + "_" + idArr[1];
      var category_id = topic_id + "_" + idArr[2];

      var expArr = [];

      var expAppendResp = this.appendExplanations(expArr, this.state.topicExplanationMap[topic_id]);
      if (expAppendResp.isAdded == false) {
        is_topic_exp_needed = 1;
      }
      else {
        expArr = expAppendResp.expArr;
      }

      var expAppendResp = this.appendExplanations(expArr, this.state.categoryExplanationMap[category_id]);
      if (expAppendResp.isAdded == false) {
        is_cat_exp_needed = 1;
      }
      else {
        expArr = expAppendResp.expArr;
      }

      var expAppendResp = this.appendExplanations(expArr, this.state.subcategoryExplanationMap[subCatUniqueID]);

      expArr = expAppendResp.expArr;

      if (this.state.subcategoryExplanationMap[subCatUniqueID] !== undefined &&
        this.state.subcategoryExplanationMap[subCatUniqueID] != null &&
        this.state.subcategoryExplanationMap[subCatUniqueID].length > 0) {

        this.setState({
          explanations: expArr,
          explanationButtonDisplay: true
        });
        return
      }

      var exp_payload = {
        explanation: {
          subject_id: parseInt(idArr[0]),
          topic_id: parseInt(idArr[1]),
          category_id: parseInt(idArr[2]),
          subcategory_id: parseInt(idArr[3])
        },
        is_topic_exp_needed: is_topic_exp_needed,
        is_cat_exp_needed: is_cat_exp_needed,

      };
      this.props.apiService({
        method: 'post',
        url: '/getAllExplanations',
        data: exp_payload
      }).then(res => {
        if (res.data.data != null) {
          var topicExplanationMap = this.state.topicExplanationMap;
          var categoryExplanationMap = this.state.categoryExplanationMap;
          var subcategoryExplanationMap = this.state.subcategoryExplanationMap;

          var finalExpArr = [];
          if (res.data.data.subcat_explanations != null) {
            subcategoryExplanationMap[subCatUniqueID] = res.data.data.subcat_explanations;
            finalExpArr = finalExpArr.concat(subcategoryExplanationMap[subCatUniqueID]);
          }

          if (is_cat_exp_needed == 0) {
            if (categoryExplanationMap[category_id] !== undefined &&
              categoryExplanationMap[category_id] !== null)
              finalExpArr = finalExpArr.concat(categoryExplanationMap[category_id]);
          } else {
            if (res.data.data.cat_explanations != null) {
              categoryExplanationMap[category_id] = res.data.data.cat_explanations;
              finalExpArr = finalExpArr.concat(categoryExplanationMap[category_id]);
            }
          }

          if (is_topic_exp_needed == 0) {
            if (topicExplanationMap[topic_id] !== undefined &&
              topicExplanationMap[topic_id] !== null)
              finalExpArr = finalExpArr.concat(topicExplanationMap[topic_id]);
          } else {
            if (res.data.data.topic_explanations != null) {
              topicExplanationMap[topic_id] = res.data.data.topic_explanations;
              finalExpArr = finalExpArr.concat(topicExplanationMap[topic_id]);
            }
          }



          if (finalExpArr.length > 0) {
            this.setState({
              topicExplanationMap: topicExplanationMap,
              categoryExplanationMap: categoryExplanationMap,
              subcategoryExplanationMap: subcategoryExplanationMap,
              explanations: finalExpArr,
              explanationButtonDisplay: true
            });
          }
        }

        console.debug('explantion =', this.state.explanations, finalExpArr)
      });

    }
  }



  handleCloseAssignment = () => {
    this.props.handleRoute("/");
  }

  onSaveAndExit() {
    this.setState({
      showSaveAndExit: true,
    })
  }

  onAnswerEntered(value) {
    this.setState({ selectedAnswer: value, showWelcomeBackMsg: false });
  }

  onAnswerChoiceDetails = (value) => {
    this.setState({ selectedAnswerDetails: { ...value }, showWelcomeBackMsg: false });
  }



  onAnswerClick(value, index) {
    let studentAnswer = "";
    // this.setState({
    // feedbackButtonVisible:false});
    //console.log("onAnswerClick ", value)
    //console.log("onAnswerClick ",index)
    var tempQuestionID = this.state.subject_id + "_" + this.state.topic_id + "_" + this.state.category_id  +  "_" +  this.state.subcategory_id + "_" + this.state.question_id;

    let currentQuestion = null;
    let answer_type = null;

    if (this.state.surveyQuestionsRetrieved === true) {
      console.log("surveyQuestionsRetrieved is true");
      console.log("tempQuestionID", tempQuestionID,this.state.questionMap);
      console.log("surveyQuestionMap = ", this.state.surveyQuestionMap[tempQuestionID]);

      currentQuestion = this.state.surveyQuestionMap[tempQuestionID];
      answer_type = currentQuestion.answer_type;
    } else {
      console.log("surveyQuestionsRetrieved is false");
      console.log("tempQuestionID", tempQuestionID,this.state.questionMap);
      currentQuestion = this.state.questionMap[tempQuestionID];
      answer_type = currentQuestion.answer_type;

    }
    console.debug("currentQuestion>>>", currentQuestion)
    if (currentQuestion && currentQuestion.question_type === 2) {
      answer_type = 0;
    }
    switch (answer_type) {
      case 0:
      case 2:
      case 30:
      case 70:
      case 50:
      case 90:
        this.setState({ selectedAnswer: value });
        studentAnswer = value;
        break;
      case 1:
      case 40:
      case 60:
      case 80:
        //checkbox
        var tempSelectedAnswerArr = this.state.selectedAnswer;

        if (tempSelectedAnswerArr !== undefined &&
          (tempSelectedAnswerArr.includes(value)) === true) {
          //Unchecked
          //Remove from selctedAnswer
          tempSelectedAnswerArr = this.removeElementFromArray(tempSelectedAnswerArr, value);

        }
        else {
          //Checked
          //Add to selectedAnswer
          if (tempSelectedAnswerArr === undefined) {
            tempSelectedAnswerArr = [];

          }
          tempSelectedAnswerArr.push(value);
        }

        console.log("tempSelectedAnswerArr", tempSelectedAnswerArr);


        this.setState({ selectedAnswer: tempSelectedAnswerArr });
        studentAnswer = tempSelectedAnswerArr;
        break;
      default:
        break;
    }

    this.setState({
      showWelcomeBackMsg: false,
    })

    if (currentQuestion.question_type === 2) { // MQG
      studentAnswer = Object.fromEntries(Object.entries(studentAnswer))
    }
    console.debug("studentAnswer.>>", studentAnswer)

  }

  showCorrectAnswer() {
    this.setState({
      feedbackPopupVisible: false,
      //feedbackOn:true,
      feedbackAnswer: null,
      feedbackButtonVisible: false,
      isCheckAnswerPressed: true,
    })
    console.debug("showCorrectAnswer");
    if (this.state.currentQuestionType === 2) {
      this.setState({
        showMQTAnswers: true,
        tryAgainButtonDisplay: false,
        showAnswerResponse: true,
        answerCorrect: true,
        displayCorrectAnswer: false,
        selectedAnswer: []
      });
    } else {



      var tempDisplayAnswerArr = this.state.displayAnswerArr;
      var tempCorrectAnswerMap = this.state.correctAnswerMap[this.state.randomQuestionID];
      var tempRandomSubCategory = this.state.randomSubCategory;
      console.log("tempCorrectAnswerMap = ", tempCorrectAnswerMap);
      console.log("tempDisplayAnswerArr = ", tempDisplayAnswerArr);
      console.log("randomCategory = ", this.state.randomCategory);
      console.log("randomSubCategory = ", this.state.randomSubCategory);
      console.log("this.state.randomQuestionID = ", this.state.randomQuestionID);
      var tempRandomId = this.state.randomQuestionID;
      console.log("this.state.correctAnswerMap = ", this.state.correctAnswerMap[tempRandomId]);
    console.debug("showCorrectAnswer");
      var correctAnswerArr =tempCorrectAnswerMap
      var selectedAns = 0
      selectedAns = correctAnswerArr
      for (var i = 0; i < tempDisplayAnswerArr?.length; i++) {
        let tempOID = tempDisplayAnswerArr[i].subject_id + "_" + tempDisplayAnswerArr[i].topic_id + "_" + tempDisplayAnswerArr[i].category_id + "_" + tempDisplayAnswerArr[i].subcategory_id + "_" +tempDisplayAnswerArr[i].question_id;
        if (tempRandomId === tempOID) {
          if (correctAnswerArr !== undefined) {
            for (var j = 0; j < correctAnswerArr.length; j++) {

              if (correctAnswerArr[j] === tempDisplayAnswerArr[i].answer_id) {
                console.log(tempDisplayAnswerArr[i], " ", correctAnswerArr[j], " ", tempDisplayAnswerArr[i].answer_id)

                tempDisplayAnswerArr[i].isChecked = true
              }
            }
          }
          else {

          }


        }
      }
      console.log("tempDisplayAnswerArr", tempDisplayAnswerArr);
      console.log("index in i ", selectedAns);
      this.setState({
        displayAnswerArr: tempDisplayAnswerArr,
        //hideNext:false,
        tryAgainButtonDisplay: false,
        showAnswerResponse: true,
        answerCorrect: true,
        selectedAnswer: [],
        selectedAnswers:[],
      });

      if (this.state.answerType === 3) {
        this.setState({ showRPAnswer: true });
      }
      const { currentQuestionType, answerType, currentVectorVariable, randomSubCategory, randomQuestionID, questionMap } = this.state;
      if (currentQuestionType === 3 && answerType === 2  || (currentQuestionType === 0 && answerType === 90)) {
        const tempQuestionID = this.state.randomQuestionID;
        const currentQuestion = questionMap[tempQuestionID];
        const {
          vector_answer_formulas,
          vector_settings_data
        } = currentQuestion;
        let correctAnswerVectors = {};
        if(currentQuestionType === 0 && answerType === 90) {
          let tempVectorVariable = vector_answer_formulas.filter(
            (vector) => !vector?.isStaticVector && !vector?.isIncorrectAnswer
          );
          let vectorVariable = VectorParser.buildQuestionVariablesMap(tempVectorVariable)

          for (let index = 0; index < tempVectorVariable.length; index++) {
            correctAnswerVectors[index] = VectorParser.generateAnswerVector(tempVectorVariable[index], vectorVariable, vector_settings_data);
          };
          const orderVectorArr = VectorParser.getMagnitudeAndSort([...Object.values(correctAnswerVectors)])
          for (let index = 0; index < orderVectorArr.length; index++) {
            correctAnswerVectors[index] = orderVectorArr[index];
          };
          this.setState({ showVectorAnswer: true, correctAnswerVectors: correctAnswerVectors });

        } else {

          for (let index = 0; index < vector_answer_formulas.length; index++) {
            correctAnswerVectors[index] = VectorParser.generateAnswerVector(vector_answer_formulas[index], currentVectorVariable, vector_settings_data);
          };
          const orderVectorArr = VectorParser.getMagnitudeAndSort([...Object.values(correctAnswerVectors)])
          for (let index = 0; index < orderVectorArr.length; index++) {
            correctAnswerVectors[index] = orderVectorArr[index];
          };
          this.setState({ showVectorAnswer: true, correctAnswerVectors: correctAnswerVectors });
        }
      }
    }
    // this.findFeedbackText(selectedAns, true);
    // this.onFeedbackClick();

  }

  addActivityLog = (logText) => {
    if (this.props.apiService === null || this.props.apiService === undefined) return;

    let ids = this.state.randomSubCategory.split("_")

    let payload = {
      quizID: this.state.quizId,
      subjectID: parseInt(ids[0]),
      topicID: parseInt(ids[1]),
      categoryID: parseInt(ids[2]),
      subcategoryID: parseInt(ids[3]),
      questionID: this.state.randomQuestionID,
      log: logText,
      activityTypeID: 18 // Question Answer
    }

    console.debug("addActivityLog", payload,);
  }

  getCurrentCategoryName() {
    let categoryName = "";
    if (this.state.categoriesMap && this.state.randomCategory) {
      const title = this.state.categoriesMap[this.state.randomCategory].categoryLabel != "" ? this.state.categoriesMap[this.state.randomCategory].categoryLabel : this.state.categoriesMap[this.state.randomCategory].categoryName;

      categoryName = title;
    }

    return categoryName;
  }

  setCategoryGoals() {
    if (this.state.categoriesData) {
      let cat = this.state.categoriesData?.find(cat => {
        let key = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
        if (key === this.state.randomCategory) return cat
      })

      if (cat) {
        console.debug("cat GOALS", cat, cat.currentAccuracyGoal, cat.currentTimeGoal)
        this.setState({
          categoryAccuracyGoal: cat.accuracyGoal,
          categoryTimeGoal: cat.timeGoal,
          currentAccuracyGoal: cat.currentAccuracyGoal ? cat.currentAccuracyGoal : 0,
          currentTimeGoal: cat.currentTimeGoal ? cat.currentTimeGoal : 0,
        })
      }

      // console.debug("this.state.categoriesData", this.state.categoriesData, this.state.randomCategory, cat);
    }
  }

  handleHideNavAndCat = () => {
    this.setState({
      hideNavAndCat: !this.state.hideNavAndCat
    })
  }

  handleHideQuestion = () => {
    this.setState({
      hideQuestion: !this.state.hideQuestion
    })
  }

  hasValidValue = (data, question) => {
    if (data === null || data === undefined) {
      return false;
    }

    let {question_type, answer_type} = question;
    if (question_type === 2) {
      return this.checkIfMQTAnswersSelectedForQuestion(question, data);
    }
    
    const jsonString = JSON.stringify(data);
    console.debug("jsonString>>>", jsonString)

    return jsonString !== '""' && jsonString !== '{}' && jsonString !== '[]';
  };


  render() {
    //console.debug("this.state.isTest, this.state.onePageMode>>", this.state.isTest, this.state.onePageMode, this.state.pageLoading, this.state.onePageTestLoading)
    //Show Splash Screen
    if (this.state.pageLoading || this.state.onePageTestLoading) {
      return <LoadingSpinner />;
    }


    return (

      <div
        className='sf-takequiz-container position-relative'
        style={{
          top: this.state.hideNavAndCat ? '10px' : "78px",
          bottom: this.state.hideNavAndCat ? '10px' : "60px",
          // height: this.state.hideNavAndCat ? '100%' : 'calc(100% - 130px)'
          height: this.state.isTest && this.state.onePageMode ? 'fit-content' : (this.state.hideNavAndCat ? '100%' : 'calc(100% - 130px)'),
          backgroundColor:"#fff !important"
        }}
      >
        <Dialog open={this.state.showSaveAndExit}>
          <DialogTitle>
              <center>
                Are you sure you want to exit?
              </center>
          </DialogTitle>
          <div className='my-2 mb-4 d-flex justify-content-center align-items-center' style={{
            gap:'12px'
          }}>
                <Button color='primary' variant='contained' onClick={this.handleCloseAssignment}>Yes</Button>
                <Button color='primary' variant='outlined'
                onClick={() => {
                  this.setState({
                    showSaveAndExit: false,
                  })
                }}
                >No</Button>
          </div>
        </Dialog>
        <span style={{
          display: this.state.hideNavAndCat ? 'none' : 'block',
        }}>
          <SFTakequizNavbar
            isAnonymous={this.state.isAnonymous}
            onShowCategorySelection={this.onShowCategorySelection}
            courseName={this.state.courseName}
            {...this.props}
            showFreeChoice={this.state.showFreeChoice}
            currentQuestionType={this.state.currentQuestionType}
            onSaveAndExit={this.onSaveAndExit}
            practiceCount={this.state.practiceCount}
            onePageMode={this.state.onePageMode}
            onePageTestSaving={this.state.onePageTestSaving}
            lastSavedAt={this.state.lastSavedAt}
          />
        </span>

        <span style={{
          display: this.state.hideNavAndCat ? 'none' : 'inline',
        }}>
            <div className='justify-content-start  sf-category-progress-container' style={{ gap: '1rem' }}> 
            </div>  
        </span>
        
        <div className='sf-main-container'
        style={{
          height:'100%',
        }}>
        <div className='sf-qa-container h-100'
        style={{
          width: '100%'
        }}
          
        >
         <SFQuestionAndAnswer
          compact={false}
          questionText={this.state.displayQuestionText}
          imageCaption=""
          onStartClick={this.onStartClick}
          title="questiontext"
          splashText={this.state.quizBundle.splashScreen}
          questionImage={questionImage}
          onAnswerEntered={this.onAnswerEntered}
          answerCorrect={this.state.answerCorrect}
          showAnswerResponse={this.state.showAnswerResponse}
          displayAnswerArr={this.state.displayAnswerArr}
          answerType={this.state.answerType}
          onAnswerClick={this.onAnswerClick}
          forceUpdateHandler={this.state.forceUpdateHandler}
          selectedAnswers={this.state.selectedAnswer}
          answerDisplayStyle={this.state.answerDisplayStyle}
          displayCorrectAnswer={this.state.displayCorrectAnswer}
          currentQuestionType={this.state.currentQuestionType}
          currentVariableMap={this.state.currentVariableMap}
          mqt_options={this.state.mqt_options}
          questionID={this.state.randomSubCategory + "_" + this.state.randomQuestionID}
          showMQTAnswers={this.state.showMQTAnswers}
          answer_formula={this.state.answer_formula}
          showRPAnswer={this.state.showRPAnswer}
          showVectorAnswer={this.state.showVectorAnswer}
          correctAnswerVectors={this.state.correctAnswerVectors}
          onSubmit={this.onSubmitClick}
          onAnswerChoiceDetails={this.onAnswerChoiceDetails}
          currentVectorVariable={this.state.currentVectorVariable}
          currentVectorSettings={this.state.currentVectorSettings}
          vectorAnswerFormulas={this.state.vectorAnswerFormulas}
          isMobile={isMobile}
          freeFormVectorOptions={this.state.freeFormVectorOptions}
          vectorBelowQuestionText={this.state.vectorBelowQuestionText}
          isCurrentQuestionNonGraded={this.state.isCurrentQuestionNonGraded}
          reasoningElements={this.state.reasoningElements}
          connectingWords={this.state.connectingWords}
          conclusionSentences={this.state.conclusionSentences}
          count={this.state.count}
          showReasoningElementCategoryInfo={this.state.showReasoningElementCategoryInfo}
          addActivityLog={this.addActivityLog}
          handleHideNavAndCat={this.handleHideNavAndCat}
          hideNavAndCat={this.state.hideNavAndCat}
          hideQuestion={this.state.hideQuestion}
          handleHideQuestion={this.handleHideQuestion}
          showSubmitLoader={this.state.showSubmitLoader}
          question_attempt={this.state.question_attempt}
          addSingleQuestionAnswerState={(payload) => {
            console.debug("this.state.randomQuestion>>>", this.state.currentQuestionObj, payload)
            if (this.state.currentQuestionObj) {
              this.addSingleQuestionAnswerState(payload, this.state.currentQuestionObj)
            }
          }}
          alreadyPickedAnswer={this.state.alreadyPickedAnswer}
          showWelcomeBackMsg={this.state.showWelcomeBackMsg}
        />
        </div>

          </div>

        {/* {this.state.explanationGalleryVisible === true ?

          <ExplanationGallery
            closeClick={this.onExplanationClick}
            elapsedTime={this.saveElapsedTimeForExplanations}
            apiService={this.props.apiService}
            visibility={this.state.explanationGalleryVisible}
            explanations={this.state.explanations}

          />
          : ''
        } */}
         {this.state.explanationGalleryVisible ? 
            <ExplanationAndTutorials
                quizID={this.state.quizId}
                subcategoryKey={this.state.randomSubCategory}
                explanations={this.state.explanations}
                readOnly={true}
                handleClose={() => this.setState({
                  explanationGalleryVisible: false,
                })}
            />
          : null}


        <SFFeedbackPopup
          closeClick={this.onFeedbackCloseClick}
          visibility={this.state.feedbackPopupVisible}
          feedback={this.state.feedbackAnswer}
        />


        {/* Fixed Footer Actions */}
        <Card style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          // height: '56px',
          padding: '8px 25px',
          width: '100%',
          zIndex: 4,
          overflowX: 'auto',
          display: this.state.isTest && this.state.onePageMode ? 'none' : 'block'
        }}
          // hidden={this.state.showSubmitLoader}
          sx={{ boxShadow: 10 }}
        >

          <div className='d-flex justify-content-center h-100 align-items-center w-100 px-4' style={{ gap: '1rem', flexWrap: 'nowrap', minWidth: 'fit-content', paddingRight: "5px" }}>
            {this.state.isCheckAnswerPressed || this.state.showSubmitLoader ? "" :
              <div style={{ flex: '0 0 auto' }}>
                {!this.state.isCurrentQuestionNonGraded && this.state.showAnswerResponse ?
                  <div className='answer-feedback' style={{ marginLeft: isMobile ? '20px' : '0px' }} >
                    {this.state.answerCorrect ?
                      <div className='d-flex justify-content-start align-items-center' style={{ gap: "4px", color: '#80c75b' }}>
                        <FaRegCircleCheck fontSize={24} />
                        <div style={{ fontWeight: 'bolder', fontSize: '22px', letterSpacing: '0.5px' }}>Correct</div>
                      </div>
                      :
                      <div className='d-flex justify-content-start align-items-center' style={{ gap: "4px", color: '#BA0C2F' }}>
                        <CgCloseO fontSize={24} />
                        <div style={{ fontWeight: 'bolder', fontSize: '22px', letterSpacing: '0.5px' }}>Incorrect</div>
                      </div>
                    }
                  </div>
                  : null}
              </div>
            }

            {this.state.showSubmitLoader ? "" :
              <Button variant='outlined' size={isMobile ? 'small' : 'medium'} style={{ flex: '0 0 auto' }} hidden={!this.state.hideQuestion} onClick={this.handleHideQuestion}>Show Question</Button>
            }

            {this.state.showSubmitLoader ? "" :
              <Button size={isMobile ? 'small' : 'medium'} style={{ flex: '0 0 auto' }} variant='outlined' hidden={!this.state.tryAgainButtonDisplay} onClick={this.onPrevClick}>Try Again</Button>
            }

            {this.state.showSubmitLoader ? "" :
              <Button size={isMobile ? 'small' : 'medium'} style={{ flex: '0 0 auto' }} variant='outlined' hidden={!this.state.displayCorrectAnswer} onClick={this.showCorrectAnswer}>Check Answer</Button>
            }

            <Button size={isMobile ? 'small' : 'medium'} style={{ flex: '0 0 auto' }} variant='outlined' hidden={true}>See the Answer</Button>


            <Button size={isMobile ? 'small' : 'medium'} style={{ flex: '0 0 auto' }} variant='contained' hidden={!this.state.submitButtonDisplay && !this.state.showSubmitLoader} disabled={this.state.showSubmitLoader} onClick={this.onSubmitClick}>
              {this.state.showSubmitLoader ? <CircularProgress className='text-white' size={24} /> : 'Submit Answer'}
            </Button>
            {this.state.showSubmitLoader ? "" :
              <Button size={isMobile ? 'small' : 'medium'} style={{ flex: '0 0 auto' }} variant='outlined' hidden={!this.state.explanationButtonDisplay} onClick={this.onExplanationClick}>Explanation</Button>
            }

            {this.state.showSubmitLoader ? "" :
              <Button size={isMobile ? 'small' : 'medium'} style={{ flex: '0 0 auto' }} variant='outlined' hidden={!this.state.feedbackButtonVisible} onClick={this.onFeedbackClick}>Feedback</Button>
            }
            {this.state.showSubmitLoader ? "" :
              <Button size={isMobile ? 'small' : 'medium'} style={{ flex: '0 0 auto' }} variant='contained' hidden={this.state.hideNext || this.state.submitButtonDisplay} onClick={this.onPrevClick}>Try Again</Button>
            }
          </div>

        </Card>
      </div >

    )
  }
}


